import {gsap, Quart, Power3, Power4, Back, Quad} from 'gsap/all';
import { MotionPathPlugin } from "gsap/MotionPathPlugin";
import utils from '@/_modules/utils';
import * as THREE from 'three'
import {LightsManager} from "../../../ts/three/LightsManager";
import {TexturesManager} from "../../../ts/three/TexturesManager";
import {Materials} from "../../../ts/three/materials/Materials";
import {Spheres} from "../../../ts/three/meshes/primitives/Spheres";
import {Boxes} from "../../../ts/three/meshes/primitives/Boxes";
import {Cubes} from "../../../ts/three/meshes/primitives/Cubes";
import {Pyramids} from "../../../ts/three/meshes/primitives/Pyramids";
import {Cones} from "../../../ts/three/meshes/primitives/Cones";
import {Coins} from "../../../ts/three/meshes/primitives/Coins";
import {Rings} from "../../../ts/three/meshes/primitives/Rings";
import {HalfRings} from "../../../ts/three/meshes/primitives/HalfRings";
import {Dumplings} from "../../../ts/three/meshes/primitives/Dumplings";
import {SimpleThreeManager} from "../../../ts/three/SimpleThreeManager";
import dot_vs from './glsl/dot.vert';
import dot_fs from './glsl/dot.frag';
import ticker_vs from "./glsl/ticker.vert";
import ticker_fs from "./glsl/ticker.frag";
import bg_noise_vs from "./glsl/bg_noise.vert";
import bg_noise_fs from "./glsl/bg_noise.frag";

import {Logo} from "../../../ts/three/meshes/gltf/Logo";
import {Astronaut} from "../../../ts/three/meshes/gltf/Astronaut";
import {Airplane} from "../../../ts/three/meshes/gltf/Airplane";
import {Dinosaur} from "../../../ts/three/meshes/gltf/Dinosaur";
import {DEG2RAD} from "three/src/math/MathUtils";

class _topGl {

  //constructor() {}
  init() {
    //console.log('GL init()');
    gsap.registerPlugin(MotionPathPlugin);

    this.st= 0;
    this.breakPoint=""; // pc | tab | sp
    this.isShift=false;
    
    this.camera;
    this.controls;
    this.scene;
    this.renderer;
    
    this.wid;
    this.hei;
    this.canvasHeight;
    this.centerX;
    this.centerY;
    this.container;
    this.resolution;
    
    this.bg_noise_mesh;

    this.counter=0;
    
    this.plane_mesh;
    
    this.logo_mesh;
    this.airplane_mesh;
    this.astronaut_mesh;
    this.dinosaur_mesh;

    this.dotsContainer;

    this.rings;
    this.halfRings;
    this.spheres;
    this.pyramids;
    this.cones;
    this.coins;
    this.cubes;
    this.dumplings;

    this.status;
    this.isReady=false;
    this.isStart=false;
    this.isGlbModelsLoaded=false;

    this.dot_geometry;
    this.dotsNumber;
    this.dotsList=[];
    this.colorPalette=[
      {r:164,g:235,b:237},
      {r:251,g:210,b:206}
    ]

    this.paramObj = {
      demo:'ambr',
      control:true,
      opacity: 1.0,
      fov: 35.0,
      fogN: 1000.0,
      fogF: 2000.0,
      topStartRoteX: -0.02,
      topStartRoteY: 1.8,
      topStartRoteZ: 0,
      centerStartRoteX: -0.2,
      centerStartRoteY: 0.8,
      centerStartRoteZ: -0.9,
      rough:2,
      x: 18,
      y: -43,
      dotSize: 14,
      dotAlpha: 1.0,
      dotsNumber: 100,
      dotMoveArea: 85,
      dotZ: 1,
      dotSpeed: 15,
      dotScroll: 0.8,
      mainScroll: 0.85,
      subScroll: 0.7,
      productCenter: false,
      curviness:1,
      curvePoint:100
    };

    this.planeTop_mesh;

    //追従固定背景
    this.planePink_mesh;
    this.planeBlue_mesh;


    this.whatBg_mesh;
    this.prodBg_mesh;
    this.tickerText_mesh;
    this.circleText_mesh;
    this.playground_mesh;


    this.mouse = new THREE.Vector2();
    this.mouseClientX=0;
    this.mouseClientY=0;
    //mouse
    this.mouseChaser={x:0,y:0};
    this.mouseChaserDiff;

    this.scrollY=0;
    // レイキャストを作成
    this.raycaster = new THREE.Raycaster();
    this.currentTarget;


    //スクロール連動オブジェクト
    //LEADエリア
    this.leadObjList=[];

    this.scrollObjList=[];
    this.rectList={
      "lead":{ rect:null, x0: 0, y0: 0 },
      "ticker":{ rect:null, x0: 0, y0: 0 },
      "what":{ rect:null, x0: 0, y0: 0 },
      "casestudy":{ rect:null, x0: 0, y0: 0 },
      "about":{ rect:null, x0: 0, y0: 0 },
      "value":{ rect:null, x0: 0, y0: 0 },
      "company":{ rect:null, x0: 0, y0: 0 }
    };

    this.domArea_lead = document.getElementById("p-top__lead");
    this.domArea_ticker = document.getElementById("p-top__ticker");
    this.domArea_what = document.getElementById("p-top__what");
    this.domArea_casestudy = document.getElementById("p-top__casestudy");
    this.domArea_company = document.getElementById("p-top__company");

    this.domTickerText = document.getElementsByClassName("c-ticker")[0];
    this.domCircleText = document.getElementsByClassName("p-topCase__listCircle")[0];
    this.domPlanePink = document.getElementsByClassName("p-top__leadPlane--pink")[0];
    this.domPlaneBlue = document.getElementsByClassName("p-top__leadPlane--blue")[0];


    this.domCContainer = document.getElementById("c-container");
    
    // テクスチャ画像リスト
    this.textureObjList = {};

    // 読み込みGLBカウント
    this.glbLoadCount = 0;

    // 読み込み画像カウント
    this.imgLoadCount = 0;
    // 読み込み画像リスト
    this.imgFileList = [
      { id: "ticker_text", src: "/manage/wp-content/themes/ambr/assets/img/top/gl/ticker_text.png" },
      { id: "playground", src: "/manage/wp-content/themes/ambr/assets/img/top/gl/playground.png" },
      { id: "circle_text", src: "/manage/wp-content/themes/ambr/assets/img/top/gl/circle_text.png" },
      { id: "rough", src: "/manage/wp-content/themes/ambr/assets/img/top/gl/rough2.png" },
      { id: "bg_noise", src: "/manage/wp-content/themes/ambr/assets/img/top/gl/bg_noise.png" },
    ];

    this.pre_pc=[{"name":"tgt_planeTop","visible":true,"x":240,"y":30,"z":-120,"sX":6.35,"sY":6.35,"sZ":6.35,"rX":0,"rY":-0.7,"rZ":0},{"name":"tgt_ring1","visible":false,"x":-400,"y":2140,"z":55.55,"sX":1.15,"sY":1.15,"sZ":1.15,"rX":0,"rY":0,"rZ":0},{"name":"tgt_ring2","visible":false,"x":120,"y":1290,"z":0,"sX":0.72,"sY":0.73,"sZ":5,"rX":0,"rY":0,"rZ":0},{"name":"tgt_halfRing1","visible":false,"x":-40,"y":-2140,"z":0,"sX":1.15,"sY":1.15,"sZ":1.15,"rX":0,"rY":0,"rZ":0},{"name":"tgt_halfRing2","visible":false,"x":180,"y":-1280,"z":0,"sX":1.1,"sY":1.1,"sZ":1.1,"rX":0,"rY":0,"rZ":0},{"name":"tgt_sphere1","visible":false,"x":750,"y":710,"z":0,"sX":1,"sY":1,"sZ":1,"rX":0,"rY":0,"rZ":0},{"name":"tgt_sphere2","visible":false,"x":280,"y":-670,"z":0.1,"sX":0.55,"sY":0.55,"sZ":0.55,"rX":0,"rY":0,"rZ":0},{"name":"tgt_sphere3","visible":false,"x":160,"y":240,"z":55.55,"sX":0.3,"sY":0.3,"sZ":0.3,"rX":0,"rY":0,"rZ":0},{"name":"tgt_box1","visible":false,"x":-1060,"y":50,"z":-200,"sX":1.2,"sY":1.2,"sZ":1.2,"rX":0,"rY":0,"rZ":0},{"name":"tgt_pyramid1","visible":false,"x":1070,"y":0,"z":0,"sX":0.95,"sY":0.95,"sZ":0.95,"rX":0.35,"rY":0.93,"rZ":-0.87},{"name":"tgt_pyramid2","visible":false,"x":-400,"y":800,"z":55.55,"sX":1,"sY":1,"sZ":1,"rX":0,"rY":0,"rZ":0},{"name":"tgt_pyramid3","visible":false,"x":0,"y":-3060,"z":55.55,"sX":1,"sY":0.5,"sZ":1,"rX":0,"rY":0,"rZ":0},{"name":"tgt_cone1","visible":false,"x":-90,"y":-1890,"z":55.55,"sX":1,"sY":1,"sZ":1,"rX":0,"rY":0,"rZ":0},{"name":"tgt_cone2","visible":false,"x":-230,"y":-1160,"z":55.55,"sX":1,"sY":1,"sZ":1,"rX":0,"rY":0,"rZ":0},{"name":"tgt_coin1","visible":false,"x":30,"y":-1580,"z":55.55,"sX":1,"sY":1,"sZ":1,"rX":0,"rY":0,"rZ":0},{"name":"tgt_cube1","visible":false,"x":60,"y":-1300,"z":0,"sX":1.25,"sY":1.25,"sZ":1.25,"rX":0,"rY":0,"rZ":0},{"name":"tgt_dumplings","visible":false,"x":260,"y":760,"z":0,"sX":12,"sY":12,"sZ":12,"rX":0,"rY":0,"rZ":0},{"name":"tgt_logo","visible":false,"x":-10,"y":-740,"z":0,"sX":16.21,"sY":16.21,"sZ":16.21,"rX":0,"rY":0.17,"rZ":0.17},{"name":"tgt_astronaut","visible":false,"x":-990,"y":-440,"z":10,"sX":30,"sY":30,"sZ":30,"rX":0,"rY":0,"rZ":0},{"name":"tgt_plane","visible":false,"x":60,"y":590,"z":0,"sX":17.06,"sY":17.06,"sZ":17.06,"rX":0,"rY":0,"rZ":0},{"name":"tgt_dinosaur","visible":false,"x":940,"y":-390,"z":10,"sX":22.05,"sY":22.05,"sZ":22.05,"rX":0,"rY":0,"rZ":0}];
    this.pre_tab=[{"name":"tgt_planeTop","visible":true,"x":240,"y":30,"z":-120,"sX":6.35,"sY":6.35,"sZ":6.35,"rX":0,"rY":-0.7,"rZ":0},{"name":"tgt_ring1","visible":false,"x":-400,"y":2140,"z":55.55,"sX":1.15,"sY":1.15,"sZ":1.15,"rX":0,"rY":0,"rZ":0},{"name":"tgt_ring2","visible":false,"x":120,"y":1290,"z":0,"sX":0.72,"sY":0.73,"sZ":5,"rX":0,"rY":0,"rZ":0},{"name":"tgt_halfRing1","visible":false,"x":-40,"y":-2140,"z":0,"sX":1.15,"sY":1.15,"sZ":1.15,"rX":0,"rY":0,"rZ":0},{"name":"tgt_halfRing2","visible":false,"x":180,"y":-1280,"z":0,"sX":1.1,"sY":1.1,"sZ":1.1,"rX":0,"rY":0,"rZ":0},{"name":"tgt_sphere1","visible":false,"x":750,"y":710,"z":0,"sX":1,"sY":1,"sZ":1,"rX":0,"rY":0,"rZ":0},{"name":"tgt_sphere2","visible":false,"x":280,"y":-670,"z":0.1,"sX":0.55,"sY":0.55,"sZ":0.55,"rX":0,"rY":0,"rZ":0},{"name":"tgt_sphere3","visible":false,"x":160,"y":240,"z":55.55,"sX":0.3,"sY":0.3,"sZ":0.3,"rX":0,"rY":0,"rZ":0},{"name":"tgt_box1","visible":false,"x":-1060,"y":50,"z":-200,"sX":1.2,"sY":1.2,"sZ":1.2,"rX":0,"rY":0,"rZ":0},{"name":"tgt_pyramid1","visible":false,"x":1070,"y":0,"z":0,"sX":0.95,"sY":0.95,"sZ":0.95,"rX":0.35,"rY":0.93,"rZ":-0.87},{"name":"tgt_pyramid2","visible":false,"x":-400,"y":800,"z":55.55,"sX":1,"sY":1,"sZ":1,"rX":0,"rY":0,"rZ":0},{"name":"tgt_pyramid3","visible":false,"x":0,"y":-3060,"z":55.55,"sX":1,"sY":0.5,"sZ":1,"rX":0,"rY":0,"rZ":0},{"name":"tgt_cone1","visible":false,"x":-90,"y":-1890,"z":55.55,"sX":1,"sY":1,"sZ":1,"rX":0,"rY":0,"rZ":0},{"name":"tgt_cone2","visible":false,"x":-230,"y":-1160,"z":55.55,"sX":1,"sY":1,"sZ":1,"rX":0,"rY":0,"rZ":0},{"name":"tgt_coin1","visible":false,"x":30,"y":-1580,"z":55.55,"sX":1,"sY":1,"sZ":1,"rX":0,"rY":0,"rZ":0},{"name":"tgt_cube1","visible":false,"x":60,"y":-1300,"z":0,"sX":1.25,"sY":1.25,"sZ":1.25,"rX":0,"rY":0,"rZ":0},{"name":"tgt_dumplings","visible":false,"x":260,"y":760,"z":0,"sX":12,"sY":12,"sZ":12,"rX":0,"rY":0,"rZ":0},{"name":"tgt_logo","visible":false,"x":-10,"y":-740,"z":0,"sX":16.21,"sY":16.21,"sZ":16.21,"rX":0,"rY":0.17,"rZ":0.17},{"name":"tgt_astronaut","visible":false,"x":-990,"y":-440,"z":10,"sX":30,"sY":30,"sZ":30,"rX":0,"rY":0,"rZ":0},{"name":"tgt_plane","visible":false,"x":60,"y":590,"z":0,"sX":17.06,"sY":17.06,"sZ":17.06,"rX":0,"rY":0,"rZ":0},{"name":"tgt_dinosaur","visible":false,"x":940,"y":-390,"z":10,"sX":22.05,"sY":22.05,"sZ":22.05,"rX":0,"rY":0,"rZ":0}];
    this.pre_sp=[{"name":"tgt_planeTop","visible":true,"x":-10,"y":0,"z":-200,"sX":0.74,"sY":0.74,"sZ":0.74,"rX":0,"rY":-0.7,"rZ":0},{"name":"tgt_ring1","visible":false,"x":-40,"y":2140,"z":0,"sX":1.15,"sY":1.15,"sZ":1.15,"rX":0,"rY":0,"rZ":0},{"name":"tgt_ring2","visible":false,"x":120,"y":190,"z":55.55,"sX":0.72,"sY":0.73,"sZ":5,"rX":0,"rY":0,"rZ":0},{"name":"tgt_halfRing1","visible":false,"x":-40,"y":-2140,"z":0,"sX":1.15,"sY":1.15,"sZ":1.15,"rX":0,"rY":0,"rZ":0},{"name":"tgt_halfRing2","visible":false,"x":180,"y":-1280,"z":0,"sX":1.1,"sY":1.1,"sZ":1.1,"rX":0,"rY":0,"rZ":0},{"name":"tgt_sphere1","visible":true,"x":150,"y":190,"z":-70,"sX":0.45,"sY":0.49,"sZ":0.49,"rX":0,"rY":0,"rZ":0},{"name":"tgt_sphere2","visible":true,"x":130,"y":-250,"z":0,"sX":0.25,"sY":0.25,"sZ":0.25,"rX":0,"rY":0,"rZ":0},{"name":"tgt_sphere3","visible":false,"x":160,"y":240,"z":55.55,"sX":0.3,"sY":0.3,"sZ":0.3,"rX":0,"rY":0,"rZ":0},{"name":"tgt_box1","visible":true,"x":-110,"y":60,"z":-10,"sX":0.61,"sY":0.66,"sZ":0.66,"rX":0,"rY":0,"rZ":0},{"name":"tgt_pyramid1","visible":true,"x":150,"y":10,"z":0,"sX":0.6,"sY":0.62,"sZ":0.62,"rX":-0.61,"rY":0.7,"rZ":-0.35},{"name":"tgt_pyramid2","visible":false,"x":-400,"y":800,"z":55.55,"sX":1,"sY":1,"sZ":1,"rX":0,"rY":0,"rZ":0},{"name":"tgt_pyramid3","visible":false,"x":0,"y":40,"z":55.55,"sX":1,"sY":0.5,"sZ":1,"rX":0,"rY":0,"rZ":0},{"name":"tgt_cone1","visible":false,"x":-90,"y":310,"z":55.55,"sX":1,"sY":1,"sZ":1,"rX":0,"rY":0,"rZ":0},{"name":"tgt_cone2","visible":false,"x":-230,"y":-60,"z":55.55,"sX":1,"sY":1,"sZ":1,"rX":0,"rY":0,"rZ":0},{"name":"tgt_coin1","visible":false,"x":30,"y":2320,"z":55.55,"sX":4.76,"sY":4.76,"sZ":4.76,"rX":0,"rY":0,"rZ":0},{"name":"tgt_cube1","visible":false,"x":60,"y":-1300,"z":0,"sX":1.25,"sY":1.25,"sZ":1.25,"rX":0,"rY":0,"rZ":0},{"name":"tgt_dumplings","visible":true,"x":30,"y":300,"z":90,"sX":5,"sY":5,"sZ":5,"rX":0,"rY":0,"rZ":0},{"name":"tgt_logo","visible":true,"x":-110,"y":-150,"z":0,"sX":8.72,"sY":8.72,"sZ":8.72,"rX":0,"rY":0,"rZ":0.23},{"name":"tgt_astronaut","visible":true,"x":-120,"y":-260,"z":50,"sX":11.18,"sY":11.18,"sZ":11.18,"rX":0,"rY":0,"rZ":0},{"name":"tgt_plane","visible":true,"x":-100,"y":210,"z":150,"sX":7.91,"sY":7.91,"sZ":7.91,"rX":0,"rY":0,"rZ":0},{"name":"tgt_dinosaur","visible":true,"x":90,"y":-150,"z":10,"sX":11.89,"sY":11.89,"sZ":11.89,"rX":0,"rY":0,"rZ":0}];

    this.top_pc=[{"name":"tgt_planeTop","visible":true,"x":240,"y":30,"z":-120,"sX":1,"sY":1,"sZ":1,"rX":0,"rY":-0.7,"rZ":0},{"name":"tgt_ring1","visible":false,"x":-400,"y":2140,"z":56,"sX":1.15,"sY":1.15,"sZ":1.15,"rX":0,"rY":0,"rZ":0},{"name":"tgt_ring2","visible":false,"x":120,"y":1290,"z":0,"sX":0.72,"sY":0.73,"sZ":5,"rX":0,"rY":0,"rZ":0},{"name":"tgt_halfRing1","visible":false,"x":-40,"y":-1140,"z":0,"sX":1.15,"sY":1.15,"sZ":1.15,"rX":0,"rY":0,"rZ":0},{"name":"tgt_halfRing2","visible":false,"x":180,"y":-1280,"z":0,"sX":1.1,"sY":1.1,"sZ":1.1,"rX":0,"rY":0,"rZ":0},{"name":"tgt_sphere1","visible":true,"x":490,"y":310,"z":0,"sX":1,"sY":1,"sZ":1,"rX":0,"rY":0,"rZ":0},{"name":"tgt_sphere2","visible":true,"x":300,"y":-280,"z":0,"sX":0.55,"sY":0.55,"sZ":0.55,"rX":0,"rY":0,"rZ":0},{"name":"tgt_sphere3","visible":false,"x":160,"y":240,"z":56,"sX":0.3,"sY":0.3,"sZ":0.3,"rX":0,"rY":0,"rZ":0},{"name":"tgt_box1","visible":true,"x":40,"y":50,"z":-200,"sX":1.2,"sY":1.2,"sZ":1.2,"rX":0,"rY":0,"rZ":0},{"name":"tgt_pyramid1","visible":true,"x":570,"y":0,"z":0,"sX":0.95,"sY":0.95,"sZ":0.95,"rX":0.35,"rY":0.93,"rZ":-0.87},{"name":"tgt_pyramid2","visible":false,"x":-400,"y":800,"z":56,"sX":1,"sY":1,"sZ":1,"rX":0,"rY":0,"rZ":0},{"name":"tgt_pyramid3","visible":false,"x":0,"y":-3060,"z":56,"sX":1,"sY":0.5,"sZ":1,"rX":0,"rY":0,"rZ":0},{"name":"tgt_cone1","visible":false,"x":-90,"y":-1890,"z":56,"sX":1,"sY":1,"sZ":1,"rX":0,"rY":0,"rZ":0},{"name":"tgt_cone2","visible":false,"x":-230,"y":-1160,"z":56,"sX":1,"sY":1,"sZ":1,"rX":0,"rY":0,"rZ":0},{"name":"tgt_coin1","visible":false,"x":30,"y":-1580,"z":56,"sX":1,"sY":1,"sZ":1,"rX":0,"rY":0,"rZ":0},{"name":"tgt_cube1","visible":false,"x":60,"y":-1300,"z":0,"sX":1.25,"sY":1.25,"sZ":1.25,"rX":0,"rY":0,"rZ":0},{"name":"tgt_dumplings","visible":true,"x":300,"y":160,"z":0,"sX":15.28,"sY":15.28,"sZ":15.28,"rX":0,"rY":0,"rZ":0},{"name":"tgt_logo","visible":true,"x":-10,"y":-260,"z":0,"sX":19.7,"sY":19.7,"sZ":19.7,"rX":0,"rY":0.17,"rZ":0.17},{"name":"tgt_astronaut","visible":true,"x":-620,"y":240,"z":10,"sX":25.66,"sY":25.66,"sZ":25.66,"rX":0,"rY":0,"rZ":0},{"name":"tgt_plane","visible":true,"x":60,"y":290,"z":0,"sX":17.06,"sY":17.06,"sZ":17.06,"rX":0,"rY":0,"rZ":0},{"name":"tgt_dinosaur","visible":true,"x":340,"y":-90,"z":10,"sX":22.05,"sY":22.05,"sZ":22.05,"rX":0,"rY":0,"rZ":0}];

    this.top_tab=[{"name":"tgt_planeTop","visible":true,"x":240,"y":30,"z":-120,"sX":1,"sY":1,"sZ":1,"rX":0,"rY":-0.7,"rZ":0},{"name":"tgt_ring1","visible":false,"x":-400,"y":2140,"z":56,"sX":1.15,"sY":1.15,"sZ":1.15,"rX":0,"rY":0,"rZ":0},{"name":"tgt_ring2","visible":false,"x":120,"y":2190,"z":0,"sX":0.72,"sY":0.73,"sZ":5,"rX":0,"rY":0,"rZ":0},{"name":"tgt_halfRing1","visible":false,"x":-40,"y":-2140,"z":0,"sX":1.15,"sY":1.15,"sZ":1.15,"rX":0,"rY":0,"rZ":0},{"name":"tgt_halfRing2","visible":false,"x":180,"y":-1280,"z":0,"sX":1.1,"sY":1.1,"sZ":1.1,"rX":0,"rY":0,"rZ":0},{"name":"tgt_sphere1","visible":true,"x":420,"y":320,"z":0,"sX":0.7,"sY":0.71,"sZ":0.71,"rX":0,"rY":0,"rZ":0},{"name":"tgt_sphere2","visible":true,"x":180,"y":-310,"z":0,"sX":0.55,"sY":0.55,"sZ":0.55,"rX":0,"rY":0,"rZ":0},{"name":"tgt_sphere3","visible":false,"x":160,"y":240,"z":56,"sX":0.3,"sY":0.3,"sZ":0.3,"rX":0,"rY":0,"rZ":0},{"name":"tgt_box1","visible":true,"x":40,"y":60,"z":-170,"sX":0.98,"sY":0.99,"sZ":0.99,"rX":0,"rY":0,"rZ":0},{"name":"tgt_pyramid1","visible":true,"x":380,"y":0,"z":0,"sX":0.81,"sY":0.82,"sZ":0.82,"rX":0,"rY":0.56,"rZ":-0.7},{"name":"tgt_pyramid2","visible":false,"x":-400,"y":800,"z":56,"sX":1,"sY":1,"sZ":1,"rX":0,"rY":0,"rZ":0},{"name":"tgt_pyramid3","visible":false,"x":0,"y":2040,"z":56,"sX":1,"sY":0.5,"sZ":1,"rX":0,"rY":0,"rZ":0},{"name":"tgt_cone1","visible":false,"x":-90,"y":310,"z":56,"sX":1,"sY":1,"sZ":1,"rX":0,"rY":0,"rZ":0},{"name":"tgt_cone2","visible":false,"x":-220,"y":-60,"z":56,"sX":1,"sY":1,"sZ":1,"rX":0,"rY":0,"rZ":0},{"name":"tgt_coin1","visible":false,"x":30,"y":120,"z":56,"sX":1,"sY":1,"sZ":1,"rX":0,"rY":0,"rZ":0},{"name":"tgt_cube1","visible":false,"x":60,"y":-1300,"z":0,"sX":1.25,"sY":1.25,"sZ":1.25,"rX":0,"rY":0,"rZ":0},{"name":"tgt_dumplings","visible":true,"x":280,"y":190,"z":-20,"sX":11.37,"sY":11.37,"sZ":11.37,"rX":0,"rY":0,"rZ":0},{"name":"tgt_logo","visible":true,"x":-210,"y":-300,"z":0,"sX":18.63,"sY":18.63,"sZ":18.63,"rX":0,"rY":0,"rZ":0.14},{"name":"tgt_astronaut","visible":true,"x":-280,"y":220,"z":10,"sX":27.8,"sY":27.8,"sZ":27.8,"rX":0,"rY":0,"rZ":0},{"name":"tgt_plane","visible":true,"x":50,"y":300,"z":0,"sX":15.96,"sY":15.96,"sZ":15.96,"rX":0,"rY":0,"rZ":0},{"name":"tgt_dinosaur","visible":true,"x":280,"y":-160,"z":10,"sX":18.77,"sY":18.77,"sZ":18.77,"rX":0,"rY":0,"rZ":0}];

    this.top_sp=[{"name":"tgt_planeTop","visible":true,"x":-10,"y":0,"z":-200,"sX":0.74,"sY":0.74,"sZ":0.74,"rX":0,"rY":-0.7,"rZ":0},{"name":"tgt_ring1","visible":false,"x":-40,"y":2140,"z":0,"sX":1.15,"sY":1.15,"sZ":1.15,"rX":0,"rY":0,"rZ":0},{"name":"tgt_ring2","visible":false,"x":120,"y":190,"z":56,"sX":0.72,"sY":0.73,"sZ":5,"rX":0,"rY":0,"rZ":0},{"name":"tgt_halfRing1","visible":false,"x":-40,"y":-2140,"z":0,"sX":1.15,"sY":1.15,"sZ":1.15,"rX":0,"rY":0,"rZ":0},{"name":"tgt_halfRing2","visible":false,"x":180,"y":-1280,"z":0,"sX":1.1,"sY":1.1,"sZ":1.1,"rX":0,"rY":0,"rZ":0},{"name":"tgt_sphere1","visible":true,"x":160,"y":200,"z":-70,"sX":0.55,"sY":0.6,"sZ":0.6,"rX":0,"rY":0,"rZ":0},{"name":"tgt_sphere2","visible":true,"x":130,"y":-270,"z":0,"sX":0.32,"sY":0.32,"sZ":0.32,"rX":0,"rY":0,"rZ":0},{"name":"tgt_sphere3","visible":false,"x":160,"y":240,"z":56,"sX":0.3,"sY":0.3,"sZ":0.3,"rX":0,"rY":0,"rZ":0},{"name":"tgt_box1","visible":true,"x":-110,"y":80,"z":0,"sX":0.61,"sY":0.66,"sZ":0.66,"rX":0,"rY":0,"rZ":0},{"name":"tgt_pyramid1","visible":true,"x":150,"y":10,"z":0,"sX":0.6,"sY":0.62,"sZ":0.62,"rX":-0.61,"rY":0.7,"rZ":-0.35},{"name":"tgt_pyramid2","visible":false,"x":-400,"y":800,"z":56,"sX":1,"sY":1,"sZ":1,"rX":0,"rY":0,"rZ":0},{"name":"tgt_pyramid3","visible":false,"x":0,"y":40,"z":56,"sX":1,"sY":0.5,"sZ":1,"rX":0,"rY":0,"rZ":0},{"name":"tgt_cone1","visible":false,"x":-90,"y":310,"z":56,"sX":1,"sY":1,"sZ":1,"rX":0,"rY":0,"rZ":0},{"name":"tgt_cone2","visible":false,"x":-230,"y":-60,"z":56,"sX":1,"sY":1,"sZ":1,"rX":0,"rY":0,"rZ":0},{"name":"tgt_coin1","visible":false,"x":30,"y":2320,"z":56,"sX":4.76,"sY":4.76,"sZ":4.76,"rX":0,"rY":0,"rZ":0},{"name":"tgt_cube1","visible":false,"x":60,"y":-1300,"z":0,"sX":1.25,"sY":1.25,"sZ":1.25,"rX":0,"rY":0,"rZ":0},{"name":"tgt_dumplings","visible":true,"x":10,"y":300,"z":90,"sX":6.7,"sY":6.7,"sZ":6.7,"rX":0,"rY":0,"rZ":0},{"name":"tgt_logo","visible":true,"x":-100,"y":-200,"z":0,"sX":10.6,"sY":10.6,"sZ":10.6,"rX":0,"rY":0,"rZ":0.23},{"name":"tgt_astronaut","visible":true,"x":-110,"y":-310,"z":50,"sX":14.27,"sY":14.27,"sZ":14.27,"rX":0,"rY":0,"rZ":0},{"name":"tgt_plane","visible":true,"x":-100,"y":210,"z":150,"sX":9.61,"sY":9.61,"sZ":9.61,"rX":0,"rY":0,"rZ":0},{"name":"tgt_dinosaur","visible":true,"x":100,"y":-160,"z":10,"sX":12.48,"sY":12.48,"sZ":12.48,"rX":0,"rY":0,"rZ":0}];


    this.center_pc=[{"name":"tgt_ring1","visible":false,"x":-400,"y":1140,"z":56,"sX":1.15,"sY":1.15,"sZ":1.15,"rX":0,"rY":0,"rZ":0},{"name":"tgt_ring2","visible":false,"x":120,"y":-2590,"z":56,"sX":0.72,"sY":0.73,"sZ":5,"rX":0,"rY":0,"rZ":0},{"name":"tgt_halfRing1","visible":true,"x":-50,"y":150,"z":-150,"sX":1.02,"sY":1.05,"sZ":1.05,"rX":0,"rY":0,"rZ":0},{"name":"tgt_halfRing2","visible":true,"x":170,"y":-320,"z":-180,"sX":1.27,"sY":1.27,"sZ":1.27,"rX":0,"rY":0,"rZ":0},{"name":"tgt_sphere1","visible":true,"x":170,"y":40,"z":-250,"sX":0.6,"sY":0.6,"sZ":0.6,"rX":0,"rY":0,"rZ":0},{"name":"tgt_sphere2","visible":true,"x":80,"y":60,"z":200,"sX":0.45,"sY":0.45,"sZ":0.45,"rX":0,"rY":0,"rZ":0},{"name":"tgt_sphere3","visible":false,"x":160,"y":-2540,"z":56,"sX":0.3,"sY":0.3,"sZ":0.3,"rX":0,"rY":0,"rZ":0},{"name":"tgt_box1","visible":true,"x":-30,"y":-40,"z":430,"sX":0.63,"sY":0.65,"sZ":0.65,"rX":0,"rY":0,"rZ":0},{"name":"tgt_pyramid1","visible":true,"x":370,"y":-160,"z":480,"sX":0.63,"sY":0.64,"sZ":0.64,"rX":0.35,"rY":1.05,"rZ":-0.7},{"name":"tgt_pyramid2","visible":false,"x":-400,"y":800,"z":56,"sX":1,"sY":1,"sZ":1,"rX":0,"rY":0,"rZ":0},{"name":"tgt_pyramid3","visible":false,"x":-500,"y":-1040,"z":56,"sX":1,"sY":0.5,"sZ":1,"rX":0,"rY":0,"rZ":0},{"name":"tgt_cone1","visible":false,"x":-90,"y":-2610,"z":56,"sX":1,"sY":1,"sZ":1,"rX":0,"rY":0,"rZ":0},{"name":"tgt_cone2","visible":false,"x":-1130,"y":-1160,"z":56,"sX":1,"sY":1,"sZ":1,"rX":0,"rY":0,"rZ":0},{"name":"tgt_coin1","visible":false,"x":30,"y":-2320,"z":56,"sX":1,"sY":1,"sZ":1,"rX":0,"rY":0,"rZ":0},{"name":"tgt_cube1","visible":false,"x":60,"y":-2500,"z":56,"sX":1.25,"sY":1.25,"sZ":1.25,"rX":0,"rY":0,"rZ":0},{"name":"tgt_dumplings","visible":true,"x":330,"y":80,"z":-20,"sX":12,"sY":12,"sZ":12,"rX":0,"rY":0,"rZ":0},{"name":"tgt_logo","visible":true,"x":110,"y":-130,"z":180,"sX":27.38,"sY":27.38,"sZ":27.38,"rX":0.03,"rY":0.35,"rZ":0.17},{"name":"tgt_astronaut","visible":true,"x":-280,"y":230,"z":-340,"sX":25.72,"sY":25.72,"sZ":25.72,"rX":0,"rY":0,"rZ":0},{"name":"tgt_plane","visible":true,"x":170,"y":170,"z":0,"sX":13.69,"sY":13.69,"sZ":13.69,"rX":0,"rY":0,"rZ":0},{"name":"tgt_dinosaur","visible":true,"x":-170,"y":-290,"z":-70,"sX":17.56,"sY":17.56,"sZ":17.56,"rX":0,"rY":0,"rZ":0}];

    this.center_tab=[{"name":"tgt_ring1","visible":false,"x":-400,"y":1140,"z":56,"sX":1.15,"sY":1.15,"sZ":1.15,"rX":0,"rY":0,"rZ":0},{"name":"tgt_ring2","visible":false,"x":120,"y":-1190,"z":56,"sX":0.72,"sY":0.73,"sZ":5,"rX":0,"rY":0,"rZ":0},{"name":"tgt_halfRing1","visible":true,"x":-50,"y":170,"z":-150,"sX":0.76,"sY":0.79,"sZ":0.79,"rX":0,"rY":0,"rZ":0},{"name":"tgt_halfRing2","visible":true,"x":70,"y":-120,"z":0,"sX":0.62,"sY":0.62,"sZ":0.62,"rX":0,"rY":0,"rZ":0},{"name":"tgt_sphere1","visible":true,"x":80,"y":70,"z":-100,"sX":0.28,"sY":0.28,"sZ":0.28,"rX":0,"rY":0,"rZ":0},{"name":"tgt_sphere2","visible":true,"x":-50,"y":90,"z":100,"sX":0.3,"sY":0.31,"sZ":0.31,"rX":0,"rY":0,"rZ":0},{"name":"tgt_sphere3","visible":false,"x":160,"y":-1240,"z":56,"sX":0.3,"sY":0.3,"sZ":0.3,"rX":0,"rY":0,"rZ":0},{"name":"tgt_box1","visible":true,"x":-110,"y":10,"z":440,"sX":0.44,"sY":0.47,"sZ":0.47,"rX":0,"rY":0,"rZ":0},{"name":"tgt_pyramid1","visible":true,"x":120,"y":-30,"z":200,"sX":0.42,"sY":0.45,"sZ":0.45,"rX":-0.61,"rY":0.7,"rZ":-0.35},{"name":"tgt_pyramid2","visible":false,"x":-400,"y":800,"z":56,"sX":1,"sY":1,"sZ":1,"rX":0,"rY":0,"rZ":0},{"name":"tgt_pyramid3","visible":false,"x":0,"y":-1040,"z":56,"sX":1,"sY":0.5,"sZ":1,"rX":0,"rY":0,"rZ":0},{"name":"tgt_cone1","visible":false,"x":-90,"y":-1310,"z":56,"sX":1,"sY":1,"sZ":1,"rX":0,"rY":0,"rZ":0},{"name":"tgt_cone2","visible":false,"x":-230,"y":-1060,"z":56,"sX":1,"sY":1,"sZ":1,"rX":0,"rY":0,"rZ":0},{"name":"tgt_coin1","visible":false,"x":30,"y":-1120,"z":56,"sX":1,"sY":1,"sZ":1,"rX":0,"rY":0,"rZ":0},{"name":"tgt_cube1","visible":false,"x":60,"y":-1300,"z":56,"sX":1.25,"sY":1.25,"sZ":1.25,"rX":0,"rY":0,"rZ":0},{"name":"tgt_dumplings","visible":true,"x":150,"y":140,"z":-100,"sX":7.39,"sY":7.39,"sZ":7.39,"rX":0,"rY":0,"rZ":0},{"name":"tgt_logo","visible":true,"x":10,"y":-20,"z":50,"sX":16.85,"sY":16.85,"sZ":16.85,"rX":0,"rY":0,"rZ":0.23},{"name":"tgt_astronaut","visible":true,"x":-130,"y":110,"z":130,"sX":13.59,"sY":13.59,"sZ":13.59,"rX":0,"rY":0,"rZ":0},{"name":"tgt_plane","visible":true,"x":50,"y":150,"z":100,"sX":9.22,"sY":9.22,"sZ":9.22,"rX":0,"rY":0,"rZ":0},{"name":"tgt_dinosaur","visible":true,"x":-100,"y":-130,"z":30,"sX":11.86,"sY":11.86,"sZ":11.86,"rX":0,"rY":0,"rZ":0}];

    this.center_sp=[{"name":"tgt_ring1","visible":false,"x":-400,"y":1140,"z":56,"sX":1.15,"sY":1.15,"sZ":1.15,"rX":0,"rY":0,"rZ":0},{"name":"tgt_ring2","visible":false,"x":120,"y":-1190,"z":56,"sX":0.72,"sY":0.73,"sZ":5,"rX":0,"rY":0,"rZ":0},{"name":"tgt_halfRing1","visible":true,"x":-50,"y":170,"z":-150,"sX":0.76,"sY":0.79,"sZ":0.79,"rX":0,"rY":0,"rZ":0},{"name":"tgt_halfRing2","visible":true,"x":70,"y":-120,"z":0,"sX":0.62,"sY":0.62,"sZ":0.62,"rX":0,"rY":0,"rZ":0},{"name":"tgt_sphere1","visible":true,"x":80,"y":70,"z":-100,"sX":0.28,"sY":0.28,"sZ":0.28,"rX":0,"rY":0,"rZ":0},{"name":"tgt_sphere2","visible":true,"x":-50,"y":90,"z":100,"sX":0.3,"sY":0.31,"sZ":0.31,"rX":0,"rY":0,"rZ":0},{"name":"tgt_sphere3","visible":false,"x":160,"y":-1240,"z":56,"sX":0.3,"sY":0.3,"sZ":0.3,"rX":0,"rY":0,"rZ":0},{"name":"tgt_box1","visible":true,"x":-140,"y":10,"z":110,"sX":0.49,"sY":0.52,"sZ":0.52,"rX":0,"rY":0,"rZ":0},{"name":"tgt_pyramid1","visible":true,"x":120,"y":-30,"z":200,"sX":0.38,"sY":0.41,"sZ":0.41,"rX":-0.61,"rY":0.7,"rZ":-0.35},{"name":"tgt_pyramid2","visible":false,"x":-400,"y":800,"z":56,"sX":1,"sY":1,"sZ":1,"rX":0,"rY":0,"rZ":0},{"name":"tgt_pyramid3","visible":false,"x":0,"y":-1040,"z":56,"sX":1,"sY":0.5,"sZ":1,"rX":0,"rY":0,"rZ":0},{"name":"tgt_cone1","visible":false,"x":-90,"y":-1310,"z":56,"sX":1,"sY":1,"sZ":1,"rX":0,"rY":0,"rZ":0},{"name":"tgt_cone2","visible":false,"x":-230,"y":-1060,"z":56,"sX":1,"sY":1,"sZ":1,"rX":0,"rY":0,"rZ":0},{"name":"tgt_coin1","visible":false,"x":30,"y":-1120,"z":56,"sX":1,"sY":1,"sZ":1,"rX":0,"rY":0,"rZ":0},{"name":"tgt_cube1","visible":false,"x":60,"y":-1300,"z":56,"sX":1.25,"sY":1.25,"sZ":1.25,"rX":0,"rY":0,"rZ":0},{"name":"tgt_dumplings","visible":true,"x":140,"y":170,"z":-100,"sX":7.39,"sY":7.39,"sZ":7.39,"rX":0,"rY":0,"rZ":0},{"name":"tgt_logo","visible":true,"x":10,"y":-20,"z":50,"sX":16.85,"sY":16.85,"sZ":16.85,"rX":0,"rY":0,"rZ":0.23},{"name":"tgt_astronaut","visible":true,"x":-130,"y":110,"z":130,"sX":13.59,"sY":13.59,"sZ":13.59,"rX":0,"rY":0,"rZ":0},{"name":"tgt_plane","visible":true,"x":50,"y":150,"z":100,"sX":9.22,"sY":9.22,"sZ":9.22,"rX":0,"rY":0,"rZ":0},{"name":"tgt_dinosaur","visible":true,"x":-100,"y":-130,"z":30,"sX":11.86,"sY":11.86,"sZ":11.86,"rX":0,"rY":0,"rZ":0}];

    this.bottom_pc=[{"name":"tgt_planeTop","visible":false,"x":1270,"y":-1000,"z":55.55,"sX":1,"sY":1,"sZ":1,"rX":0,"rY":-2.8,"rZ":0},{"name":"tgt_dumplings","visible":false,"x":2350,"y":50,"z":55.55,"sX":12,"sY":12,"sZ":12,"rX":0,"rY":0,"rZ":0},{"name":"tgt_ring1","visible":true,"x":-230,"y":130,"z":-200,"sX":1,"sY":1,"sZ":1,"rX":0,"rY":0,"rZ":0},{"name":"tgt_ring2","visible":true,"x":140,"y":220,"z":-200,"sX":0.72,"sY":0.73,"sZ":5,"rX":-0.87,"rY":-0.32,"rZ":0.58},{"name":"tgt_halfRing1","visible":true,"x":-340,"y":-160,"z":-410,"sX":1.04,"sY":1.05,"sZ":1.05,"rX":0,"rY":0,"rZ":0},{"name":"tgt_halfRing2","visible":true,"x":280,"y":40,"z":-300,"sX":0.99,"sY":1.01,"sZ":1.01,"rX":0,"rY":0,"rZ":0},{"name":"tgt_sphere1","visible":true,"x":-230,"y":270,"z":-100,"sX":0.5,"sY":0.5,"sZ":0.5,"rX":0,"rY":0,"rZ":0},{"name":"tgt_sphere2","visible":true,"x":360,"y":-180,"z":-199.9,"sX":0.55,"sY":0.55,"sZ":0.55,"rX":0,"rY":0,"rZ":0},{"name":"tgt_sphere3","visible":true,"x":210,"y":-340,"z":-1000,"sX":0.4,"sY":0.41,"sZ":0.41,"rX":0,"rY":0,"rZ":0},{"name":"tgt_box1","visible":true,"x":-270,"y":-280,"z":0,"sX":0.7,"sY":0.7,"sZ":0.7,"rX":0,"rY":0,"rZ":0},{"name":"tgt_pyramid1","visible":true,"x":270,"y":90,"z":0,"sX":0.77,"sY":0.77,"sZ":0.77,"rX":0.28,"rY":4.2,"rZ":-2.8},{"name":"tgt_pyramid2","visible":true,"x":-120,"y":-140,"z":250,"sX":0.7,"sY":0.7,"sZ":0.7,"rX":0,"rY":0,"rZ":0},{"name":"tgt_pyramid3","visible":true,"x":-30,"y":190,"z":-300,"sX":0.68,"sY":0.34,"sZ":0.68,"rX":4.56,"rY":0.05,"rZ":1.22},{"name":"tgt_cone1","visible":true,"x":-60,"y":280,"z":100,"sX":0.9,"sY":0.91,"sZ":0.91,"rX":0,"rY":0,"rZ":0},{"name":"tgt_cone2","visible":true,"x":-220,"y":-150,"z":-200,"sX":1,"sY":1,"sZ":1,"rX":0,"rY":0,"rZ":0},{"name":"tgt_coin1","visible":true,"x":30,"y":-120,"z":0,"sX":1,"sY":1,"sZ":1,"rX":0,"rY":0,"rZ":0},{"name":"tgt_cube1","visible":true,"x":30,"y":-180,"z":500,"sX":0.83,"sY":0.85,"sZ":0.85,"rX":0,"rY":0,"rZ":0},{"name":"tgt_logo","visible":true,"x":10,"y":"0","z":0,"sX":23.47,"sY":23.47,"sZ":23.47,"rX":-0.05,"rY":-0.13,"rZ":-0.07},{"name":"tgt_astronaut","visible":true,"x":250,"y":260,"z":10,"sX":20.85,"sY":20.85,"sZ":20.85,"rX":0,"rY":0,"rZ":0},{"name":"tgt_plane","visible":true,"x":-260,"y":140,"z":200,"sX":11.32,"sY":11.32,"sZ":11.32,"rX":0,"rY":0,"rZ":0},{"name":"tgt_dinosaur","visible":true,"x":170,"y":-130,"z":300,"sX":14.63,"sY":14.63,"sZ":14.63,"rX":0,"rY":0,"rZ":0}];

    this.bottom_tab=[{"name":"tgt_planeTop","visible":false,"x":1270,"y":-1000,"z":55.55,"sX":1,"sY":1,"sZ":1,"rX":0,"rY":-0.7,"rZ":0},{"name":"tgt_dumplings","visible":false,"x":2350,"y":50,"z":55.55,"sX":7,"sY":7,"sZ":7,"rX":0,"rY":0,"rZ":0},{"name":"tgt_ring1","visible":true,"x":-220,"y":80,"z":-200,"sX":0.9,"sY":0.91,"sZ":0.91,"rX":0,"rY":0,"rZ":0},{"name":"tgt_ring2","visible":true,"x":120,"y":150,"z":-200,"sX":0.65,"sY":0.66,"sZ":4.93,"rX":-0.87,"rY":-0.17,"rZ":0},{"name":"tgt_halfRing1","visible":true,"x":-390,"y":-140,"z":-460,"sX":0.94,"sY":0.95,"sZ":0.95,"rX":0,"rY":0,"rZ":0},{"name":"tgt_halfRing2","visible":true,"x":330,"y":-50,"z":-300,"sX":0.85,"sY":0.88,"sZ":0.88,"rX":0,"rY":0,"rZ":0},{"name":"tgt_sphere1","visible":true,"x":-270,"y":190,"z":-100,"sX":0.35,"sY":0.36,"sZ":0.36,"rX":0,"rY":0,"rZ":0},{"name":"tgt_sphere2","visible":true,"x":350,"y":-170,"z":-199.9,"sX":0.45,"sY":0.45,"sZ":0.45,"rX":0,"rY":0,"rZ":0},{"name":"tgt_sphere3","visible":true,"x":210,"y":-370,"z":-1000,"sX":0.34,"sY":0.36,"sZ":0.36,"rX":0,"rY":0,"rZ":0},{"name":"tgt_box1","visible":true,"x":-290,"y":-240,"z":0,"sX":0.63,"sY":0.64,"sZ":0.64,"rX":0,"rY":0,"rZ":0},{"name":"tgt_pyramid1","visible":true,"x":230,"y":90,"z":0,"sX":0.66,"sY":0.67,"sZ":0.67,"rX":0.35,"rY":1.05,"rZ":-0.7},{"name":"tgt_pyramid2","visible":true,"x":-120,"y":-140,"z":250,"sX":0.57,"sY":0.58,"sZ":0.58,"rX":0,"rY":0,"rZ":0},{"name":"tgt_pyramid3","visible":true,"x":-30,"y":130,"z":-300,"sX":0.63,"sY":0.32,"sZ":0.64,"rX":0,"rY":0,"rZ":0},{"name":"tgt_cone1","visible":true,"x":-120,"y":200,"z":100,"sX":0.77,"sY":0.79,"sZ":0.79,"rX":0,"rY":0,"rZ":0},{"name":"tgt_cone2","visible":true,"x":-270,"y":-100,"z":-200,"sX":0.9,"sY":0.91,"sZ":0.91,"rX":0,"rY":0,"rZ":0},{"name":"tgt_coin1","visible":true,"x":30,"y":-120,"z":0,"sX":0.9,"sY":0.9,"sZ":0.9,"rX":0,"rY":0,"rZ":0},{"name":"tgt_cube1","visible":true,"x":20,"y":-130,"z":500,"sX":0.64,"sY":0.67,"sZ":0.67,"rX":0,"rY":0,"rZ":0},{"name":"tgt_logo","visible":true,"x":10,"y":-30,"z":0,"sX":19.6,"sY":19.6,"sZ":19.6,"rX":0.03,"rY":-0.17,"rZ":0},{"name":"tgt_astronaut","visible":true,"x":230,"y":190,"z":10,"sX":14.63,"sY":14.63,"sZ":14.63,"rX":0,"rY":0,"rZ":0},{"name":"tgt_plane","visible":true,"x":-280,"y":100,"z":220,"sX":8.32,"sY":8.32,"sZ":8.32,"rX":0,"rY":0,"rZ":0},{"name":"tgt_dinosaur","visible":true,"x":150,"y":-100,"z":320,"sX":10.75,"sY":10.75,"sZ":10.75,"rX":0,"rY":0,"rZ":0}];

    this.bottom_sp=[{"name":"tgt_planeTop","visible":false,"x":1270,"y":-1000,"z":55.55,"sX":1,"sY":1,"sZ":1,"rX":0,"rY":-1.4,"rZ":0},{"name":"tgt_dumplings","visible":false,"x":2350,"y":50,"z":55.55,"sX":5,"sY":5,"sZ":5,"rX":0,"rY":0,"rZ":0},{"name":"tgt_ring1","visible":true,"x":-100,"y":"0","z":-200,"sX":0.66,"sY":0.68,"sZ":0.68,"rX":0,"rY":0,"rZ":0},{"name":"tgt_ring2","visible":true,"x":40,"y":20,"z":-200,"sX":0.31,"sY":0.33,"sZ":3.47,"rX":-0.7,"rY":0.17,"rZ":0},{"name":"tgt_halfRing1","visible":true,"x":-150,"y":-190,"z":-410,"sX":0.69,"sY":0.72,"sZ":0.72,"rX":0,"rY":0,"rZ":0},{"name":"tgt_halfRing2","visible":true,"x":90,"y":-110,"z":-300,"sX":0.62,"sY":0.66,"sZ":0.66,"rX":0,"rY":0,"rZ":0},{"name":"tgt_sphere1","visible":true,"x":-90,"y":110,"z":-600,"sX":0.38,"sY":0.4,"sZ":0.4,"rX":0,"rY":0,"rZ":0},{"name":"tgt_sphere2","visible":true,"x":180,"y":-180,"z":-199.9,"sX":0.33,"sY":0.34,"sZ":0.34,"rX":0,"rY":0,"rZ":0},{"name":"tgt_sphere3","visible":true,"x":110,"y":-340,"z":-1000,"sX":0.4,"sY":0.41,"sZ":0.41,"rX":0,"rY":0,"rZ":0},{"name":"tgt_box1","visible":true,"x":-130,"y":-230,"z":0,"sX":0.42,"sY":0.43,"sZ":0.43,"rX":0,"rY":0,"rZ":0},{"name":"tgt_pyramid1","visible":true,"x":120,"y":"0","z":0,"sX":0.48,"sY":0.5,"sZ":0.5,"rX":-1.74,"rY":0.7,"rZ":-0.34},{"name":"tgt_pyramid2","visible":true,"x":-60,"y":-160,"z":250,"sX":0.42,"sY":0.43,"sZ":0.43,"rX":-2.1,"rY":0.34,"rZ":0.7},{"name":"tgt_pyramid3","visible":true,"x":-30,"y":-10,"z":-300,"sX":0.42,"sY":0.21,"sZ":0.43,"rX":2.79,"rY":0.52,"rZ":1.92},{"name":"tgt_cone1","visible":true,"x":-40,"y":140,"z":100,"sX":0.54,"sY":0.57,"sZ":0.57,"rX":0,"rY":0,"rZ":0},{"name":"tgt_cone2","visible":true,"x":-150,"y":-150,"z":-200,"sX":0.57,"sY":0.59,"sZ":0.59,"rX":-5.95,"rY":3.14,"rZ":-1.4},{"name":"tgt_coin1","visible":true,"x":10,"y":-160,"z":0,"sX":0.5,"sY":0.53,"sZ":0.53,"rX":0,"rY":0,"rZ":0},{"name":"tgt_cube1","visible":true,"x":20,"y":-160,"z":500,"sX":0.44,"sY":0.48,"sZ":0.48,"rX":0,"rY":0,"rZ":0},{"name":"tgt_logo","visible":true,"x":"0","y":-100,"z":0,"sX":11.91,"sY":11.91,"sZ":11.91,"rX":0,"rY":0,"rZ":0},{"name":"tgt_astronaut","visible":true,"x":140,"y":80,"z":-390,"sX":14.63,"sY":14.63,"sZ":14.63,"rX":0,"rY":0,"rZ":0},{"name":"tgt_plane","visible":true,"x":-120,"y":30,"z":200,"sX":6.44,"sY":6.44,"sZ":6.44,"rX":0,"rY":0,"rZ":0},{"name":"tgt_dinosaur","visible":true,"x":70,"y":-130,"z":300,"sX":7.13,"sY":7.13,"sZ":7.13,"rX":0,"rY":0,"rZ":0}];


    this.moveList=[];


    this.move={

      manager:null,
      materials:null,

      meshes : [],

      // 差分値
      positions : [],
      rotations : [],

      // 角度の増分値
      positionDegrees : [],
      scaleDegrees : [],
      rotationDegrees : [],

      index:0,
      speed : 1
    };

    this.CONFIGS = [
      {
          name: 'Coin',
          type: 'coin',
          material: 'Blue',
          position: new THREE.Vector3(0, 0, 0),
          rotation: new THREE.Euler(5, 0, 0),
          loops: [
              {
                  target: 'rotation',
                  type: 'sine',
                  axis: 'z',
                  distance: 5,
                  degrees: 1
              },
              {
                  target: 'rotation',
                  type: 'add',
                  axis: 'y',
                  delta: 1
              }
          ]
      },
      {
          name: 'Sphere1',
          type: 'sphere',
          material: 'Purple',
          position: new THREE.Vector3(-10, 8, -10),
          loops: []
      },
      {
          name: 'Sphere2',
          type: 'sphere',
          material: 'Red',
          position: new THREE.Vector3(12, 0, -20),
          loops: []
      },
      {
          name: 'box',
          type: 'box',
          material: 'Pink',
          position: new THREE.Vector3(0, 12, -8),
          rotation: new THREE.Euler(-45, 0, 75),
          rotationOrder: 'XZY',
          loops: [
              {
                  target: 'rotation',
                  type: 'add',
                  axis: 'y',
                  delta: 0.3333
              },
              // 縦回転だけだと味気ないのでゆっくり別の回転も加える
              {
                  target: 'rotation',
                  type: 'add',
                  axis: 'z',
                  delta: 0.1
              },
          ]
      },
      {
          name: 'Cone',
          type: 'cone',
          material: 'Red',
          position: new THREE.Vector3(-3, 7, -3),
          rotation: new THREE.Euler(-30, 0, 10), // Yの後のZを少しだけ設定して、スクリューの動きにズレ(八の字的な)を作る
          loops: [
              {
                  target: 'rotation',
                  type: 'add',
                  axis: 'y',
                  delta: 1
              },
          ]
      },
      {
          name: 'HalfRingRight',
          type: 'halfRingRight',
          material: 'Purple',
          position: new THREE.Vector3(12, 5, -8),
          rotation: new THREE.Euler(120, 0, 180),
          loops: [
              {
                  target: 'rotation',
                  type: 'sine',
                  axis: 'x',
                  distance: 10,
                  degrees: 0.5
              },
              {
                  target: 'rotation',
                  type: 'add',
                  axis: 'z',
                  delta: -0.5
              }
          ]
      },
      {
          name: 'HalfRingRight2',
          type: 'halfRingRight2',
          material: 'Purple',
          position: new THREE.Vector3(12, 5, -8),
          rotation: new THREE.Euler(30, 60, 30),
          loops: [
              {
                  target: 'rotation',
                  type: 'sine',
                  axis: 'x',
                  distance: 10,
                  degrees: 0.5
              },
              {
                  target: 'rotation',
                  type: 'add',
                  axis: 'z',
                  delta: 0.25
              }
          ]
      },
      {
          name: 'HalfRingLeft',
          type: 'halfRingLeft',
          material: 'Purple',
          position: new THREE.Vector3(-14, -3, 5),
          rotation: new THREE.Euler(120, 0, 0),
          loops: [
              {
                  target: 'rotation',
                  type: 'sine',
                  axis: 'x',
                  distance: 15,
                  degrees: 0.5
              },
              {
                  target: 'rotation',
                  type: 'add',
                  axis: 'z',
                  delta: 0.5
              }
          ]
      },
      {
          name: 'HalfRingLeft2',
          type: 'halfRingLeft2',
          material: 'Purple',
          position: new THREE.Vector3(-14, -3, 5),
          rotation: new THREE.Euler(30, 150, 120),
          loops: [
              {
                  target: 'rotation',
                  type: 'sine',
                  axis: 'x',
                  distance: 15,
                  degrees: -0.25
              },
              {
                  target: 'rotation',
                  type: 'add',
                  axis: 'z',
                  delta: -0.25
              }
          ]
      },
      {
          name: 'Pyramid1',
          type: 'pyramid1',
          material: 'Orange',
          position: new THREE.Vector3(-14, 2, 5),
          rotation: new THREE.Euler(15, 0, -15),
          rotationOrder: 'XZY', // Yを最後にしてスクリューの動きに
          loops: [
              {
                  target: 'rotation',
                  type: 'add',
                  axis: 'y',
                  delta: 0.5
              },
          ]
      },
      {
          name: 'Pyramid2',
          type: 'pyramid2',
          material: 'Pink',
          position: new THREE.Vector3(2, -6, 5),
          rotation: new THREE.Euler(0, 0, 0),
          rotationOrder: 'XZY', // Yを最後にしてスクリューの動きに
          loops: [
              {
                  target: 'rotation',
                  type: 'add',
                  axis: 'y',
                  delta: -0.3333
              },
          ]
      },
      {
          name: 'Dinosaur',
          type: 'dinosaur',
          material: 'Dinosaur',
          position: new THREE.Vector3(7, -8, 12),
          rotation: new THREE.Euler(90, -45, 0),
          scale: new THREE.Vector3(1, 1, 1),
          rotationOrder: 'YZX',
          loops: [
              {
                  target: 'rotation',
                  type: 'sine',
                  axis: 'x',
                  distance: 10,
                  degrees: 1
              },
              {
                  target: 'rotation',
                  type: 'sine',
                  axis: 'y',
                  distance: 10,
                  degrees: 0.5
              },
          ]
      },
      {
          name: 'Airplane',
          type: 'airplane',
          material: ['Airplane', 'AirplaneWindow'],
          position: new THREE.Vector3(0, 0, 0),
          rotation: new THREE.Euler(105, 0, 30),
          rotationOrder: 'XZY', // Yを最後にして左右に傾ける
          loops: [
              {
                  target: 'rotation',
                  type: 'sine',
                  axis: 'y',
                  distance: 15,
                  degrees: 1
              },
          ]
      },
      {
          name: 'Astronaut',
          type: 'astronaut',
          material: ['Astronaut', 'AstronautMask'],
          position: new THREE.Vector3(-15, 8, 0),
          rotation: new THREE.Euler(45, 45, 0),
          scale: new THREE.Vector3(1.25, 1.25, 1.25),
          loops: [
              {
                  target: 'rotation',
                  type: 'add',
                  axis: 'y',
                  delta: 0.66
              },
              {
                  target: 'rotation',
                  type: 'add',
                  axis: 'z',
                  delta: 0.33
              }
          ]
      },
      {
          name: 'Logo',
          type: 'logo',
          material: 'Logo',
          position: new THREE.Vector3(0, 0, 2),
          rotation: new THREE.Euler(90 - 15, 0, 0),
          scale: new THREE.Vector3(2, 2, 2),
          loops: [
              {
                  target: 'rotation',
                  type: 'sine',
                  axis: 'z',
                  distance: 15,
                  degrees: 1
              }
          ]
      },
      {
          name: 'Ring',
          type: 'ring',
          material: 'Magenta',
          position: new THREE.Vector3(13, -6, 2),
          rotation: new THREE.Euler(30, 30, 0), // Zの後のXを少しだけ設定して、スクリューの動きにズレを作る
          rotationOrder: 'YZX',
          loops: [
              {
                  target: 'rotation',
                  type: 'add',
                  axis: 'z',
                  delta: 0.5
              },
          ]
      },
      {
          name: 'Ring',
          type: 'ring2',
          material: 'Magenta',
          position: new THREE.Vector3(13, -6, 2),
          rotation: new THREE.Euler(0, 0, 0), // Zの後のXを少しだけ設定して、スクリューの動きにズレを作る
          rotationOrder: 'YZX',
          loops: [
              {
                  target: 'rotation',
                  type: 'add',
                  axis: 'z',
                  delta: 0.3
              },
          ]
      },
      {
          name: 'Ring',
          type: 'ring3',
          material: 'Magenta',
          position: new THREE.Vector3(13, -6, 2),
          rotation: new THREE.Euler(45, 60, 0), // Zの後のXを少しだけ設定して、スクリューの動きにズレを作る
          rotationOrder: 'YZX',
          loops: [
              {
                  target: 'rotation',
                  type: 'add',
                  axis: 'z',
                  delta: 0.3
              },
          ]
      },
      {
          name: 'Cube',
          type: 'cube',
          material: 'Orange',
          position: new THREE.Vector3(-5, -8, 15),
          rotation: new THREE.Euler(0, 0, 0),
          loops: [
              {
                  target: 'rotation',
                  type: 'add',
                  axis: 'x',
                  delta: 0.25
              },
              {
                  target: 'rotation',
                  type: 'add',
                  axis: 'y',
                  delta: 0.333
              },
          ]
      },
      {
          name: 'Dumplings',
          type: 'dumplings',
          material: ['Dumpling1', 'Dumpling2', 'Dumpling3'],
          position: new THREE.Vector3(-2, 10, 0),
          rotation: new THREE.Euler(-10, 0, 30),
          rotationOrder: 'ZYX',
          scale: new THREE.Vector3(0.5, 0.5, 0.5),
          loops: [
              {
                  target: 'rotation',
                  type: 'add',
                  axis: 'y',
                  delta: 1
              }
          ]
      }
    ];







    const anchorsRight = [{x:800, y:-200}, {x:100, y:-this.paramObj.curvePoint}, {x:0, y:0}];
    const rawPathRight = MotionPathPlugin.arrayToRawPath(anchorsRight, {curviness:this.paramObj.curviness});
    this.pathRight =MotionPathPlugin.rawPathToString( rawPathRight );

    const anchorsLeft = [{x:-800, y:0}, {x:-100, y:-this.paramObj.curvePoint}, {x:0, y:0}];
    const rawPathLeft = MotionPathPlugin.arrayToRawPath(anchorsLeft, {curviness:this.paramObj.curviness});
    this.pathLeft =MotionPathPlugin.rawPathToString( rawPathLeft );

    document.getElementById('p-top__mv').addEventListener("mousemove", this.onMouseMove.bind(this), false);

    this.interScroll=1;

    this.el = document.getElementById('c-glCanvas');
    this.pastWidth = 0;

    this.bindResize = this.resize.bind(this);
    this.bindResize();
    window.addEventListener('resize', this.bindResize, {passive: false});
  
    // GLで使う画像を読み込み開始
    this.xLoadImages.bind(this)();

  }

  scroll(e) { 
    this.scrollY=e.scroll.y;//1フレーム遅い？
  }

  /**
   * 画像アセットをロードします
   */
  xLoadImages() {
    var loader = new THREE.TextureLoader();
    var imgFileListObj = this.imgFileList[this.imgLoadCount];
    var imgSrc = imgFileListObj.src;
    loader.load(
      imgSrc,
      (texture)=> {
        this.imgLoadCount++;
        var textureObj = {};
        textureObj.id = imgFileListObj.id;
        textureObj.texture = texture;
        textureObj.texture.magFilter = THREE.NearestFilter;//LinearFilter
        textureObj.texture.minFilter = THREE.NearestFilter;//LinearFilter
        textureObj.texture.wrapS = THREE.RepeatWrapping;
        textureObj.texture.wrapT = THREE.RepeatWrapping;
        
        this.textureObjList[textureObj.id] = textureObj.texture;

        if (this.imgLoadCount >= this.imgFileList.length) {
          
          // 画像ロード後、キャンバスの準備を開始します(→その後)
          this.xSetCanvas.bind(this)();

          this.onLoadedCheck();

        } else {
          this.onLoadedCheck();
          this.xLoadImages();
        }
      },
      undefined,
      function (err) {
        console.error("An error happened. sprite images", imgSrc);
      }
    );
  }

  /** 
   * アセットのロードをチェックします
   */
  onLoadedCheck(){
    const loadPercent=Math.round(this.imgLoadCount/this.imgFileList.length*100);

    //画像全部 & GLB4つ
    if(this.imgLoadCount>=this.imgFileList.length && this.isGlbModelsLoaded){
      //全ロード完了
      this.bindResize(true);
      this.isReady=true;

      // 毎時処理開始
      this.onEnter.bind(this)();

      //opening準備
      this.xSetPreOpening();

      //準備完了 待機
      gAMBR.mods['main'].onGlReady();
    } 
  }

  /**
   * マウス座標移動
   */
  onMouseMove(event) {
    event.preventDefault();
    this.mouseClientX=event.clientX;
    this.mouseClientY=event.clientY;
    if (this.mouse) {
      this.mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
      this.mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
    }
  }
  
  reset() {
    window.removeEventListener('resize', this.bindResize);
    delete this.bindResize;
    delete this.el;
    delete this.pastWidth;
  }

  start() {
    //console.log(":GL start()");
  }

  /** 名前からMesh,Objectを取得します */
  xGetMesh($name){
    if($name.indexOf("planeTop")>0){
      for(var i = 0; i < this.container.children.length; i++){
        var obj=this.container.children[i];
        if(obj.name===$name){
          return obj;
        }
      }
    }else{
      for(var i = 0; i < this.topContainer.children.length; i++){
        var obj=this.topContainer.children[i];
        if(obj.name===$name){
          return obj;
        }
      }
      return null;
    }
  }



  /*** canvasをセットします ***/
  xSetCanvas() {

    // シーン設定
    this.scene = new THREE.Scene();

    this.scene.fog = new THREE.Fog(0xffffff, this.paramObj.fogN, this.paramObj.fogF);

    // カメラ設定
    this.camera = new THREE.PerspectiveCamera(this.paramObj.fov, this.wid / this.canvasHeight, 1,10000);
    this.camera.position.x = 0;
    this.camera.position.y = 0;
    this.camera.position.z = 0;
    this.camera.lookAt(new THREE.Vector3(0, 0, 0));
    this.camera.frustumCulled=true;

    this.resolution = new THREE.Vector2(0,0);
  
    this.container = new THREE.Object3D();
    this.container.name="container";

    this.topContainer = new THREE.Object3D();
    this.topContainer.name="topContainer";

    this.scrollObjContainer = new THREE.Object3D();
    this.scrollObjContainer.name="scrollObjContainer";



    // BG NOISE
    const bg_noise_geo = new THREE.PlaneBufferGeometry(2, 2, 1, 1);

    const bg_noise_mat = new THREE.RawShaderMaterial({
      // シェーダを自分で指定するマテリアルを作ります
      vertexShader: bg_noise_vs,
      fragmentShader: bg_noise_fs,
      transparent: false,
      alphaTest: 0.5,
      depthTest: false,
      side: THREE.FrontSide,
      blending: THREE.NormalBlending,
      wireframe: false,

      // シェーダに渡すuniform変数の定義
      uniforms: {
        // 文字のtextureを渡す
        uNoiseTexture: { type: "t", value: this.textureObjList["bg_noise"] },
        uOffsetY: { type: "1f", value: 0.0 },
        uResolution: { type: 'v2', value: new THREE.Vector2( this.wid, this.canvasHeight ) },
      },
    });

    this.bg_noise_mesh = new THREE.Mesh( bg_noise_geo, bg_noise_mat );
    this.bg_noise_mesh.name="bg_noise";
    this.bg_noise_mesh.position.x=0;
    this.bg_noise_mesh.position.y=0;
    this.bg_noise_mesh.position.z=0;
    this.bg_noise_mesh.renderOrder=-100;
    this.scene.add( this.bg_noise_mesh );


    //plane Top
    const planeTop_geo = new THREE.PlaneGeometry( 600, 632, 1, 1 );
    const planeTop_mat = new THREE.MeshBasicMaterial( {color: 0xe3f9fa, side: THREE.DoubleSide, transparent:false} );//0xe3f9fa
    planeTop_mat.depthTest=false;
    this.planeTop_mesh = new THREE.Mesh( planeTop_geo, planeTop_mat );
    this.planeTop_mesh.name="tgt_planeTop";
    this.planeTop_mesh.position.x=420;
    this.planeTop_mesh.position.y=40;
    this.planeTop_mesh.position.z=-1000;
    this.planeTop_mesh.rotation.y=-40/180*Math.PI;
    this.container.add( this.planeTop_mesh );

    
    //plane Pink
    const planePink_geo = new THREE.PlaneGeometry( 450, 510, 1, 1 );
    const planePink_mat = new THREE.MeshBasicMaterial( {color: 0xffe6e4, side: THREE.FrontSide, transparent:false} );
    planePink_mat.depthTest=false;
    this.planePink_mesh = new THREE.Mesh( planePink_geo, planePink_mat );
    this.planePink_mesh.name="bg_planePink";
    this.planePink_mesh.position.x=0;
    this.planePink_mesh.position.y=0;
    this.planePink_mesh.position.z=0;
    this.scene.add( this.planePink_mesh );


    //plane Blue
    const planeBlue_geo = new THREE.PlaneGeometry( 412, 510, 1, 1 );
    const planeBlue_mat = new THREE.MeshBasicMaterial( {color: 0xe3f9fa, side: THREE.FrontSide, transparent:false} );
    planeBlue_mat.depthTest=false;
    this.planeBlue_mesh = new THREE.Mesh( planeBlue_geo, planeBlue_mat );
    this.planeBlue_mesh.name="bg_planeBlue";
    this.planeBlue_mesh.position.x=0;
    this.planeBlue_mesh.position.y=0;
    this.planeBlue_mesh.position.z=0;
    this.scene.add( this.planeBlue_mesh );

    
    //plane whatBg
    const whatBg_geo = new THREE.PlaneGeometry( 1, 1, 1, 1 );
    const whatBg_mat = new THREE.MeshBasicMaterial( {color: 0xfee5e3, side: THREE.FrontSide, transparent:false} );
    whatBg_mat.depthTest=false;
    this.whatBg_mesh = new THREE.Mesh( whatBg_geo, whatBg_mat );
    this.whatBg_mesh.name="bg_whatBg";
    this.whatBg_mesh.position.x=0;
    this.whatBg_mesh.position.y=0;
    this.whatBg_mesh.position.z=0;
    this.whatBg_mesh.renderOrder=-5;
    this.scene.add( this.whatBg_mesh );



    // dom 連携　TICKERテキスト
    const tickerText_geo = new THREE.PlaneGeometry( 2650, 130, 1, 1 );

    var ticker_mat = new THREE.RawShaderMaterial({
      // シェーダを自分で指定するマテリアルを作ります
      vertexShader: ticker_vs,
      fragmentShader: ticker_fs,
      transparent: true,
      alphaTest: 0.5,
      depthTest: true,
      depthWrite:false,
      side: THREE.FrontSide,
      blending: THREE.NormalBlending,
      wireframe: false,

      // シェーダに渡すuniform変数の定義
      uniforms: {
        // 文字のtextureを渡す
        uTickerTexture: { type: "t", value: this.textureObjList["ticker_text"] },
        uOffsetX: { type: "1f", value: 0.0 },
        // 時間経過
        //uTime: { type: "1f", value: 0 },
      },
    });

    this.tickerText_mesh = new THREE.Mesh( tickerText_geo, ticker_mat );
    this.tickerText_mesh.name="tgt_tickerText";
    this.tickerText_mesh.position.x=0;
    this.tickerText_mesh.position.y=0;
    this.tickerText_mesh.position.z=0;
    this.tickerText_mesh.renderOrder=-1;
    this.scene.add( this.tickerText_mesh );

    //PlayGround
    const playground_geo = new THREE.PlaneGeometry( 256, 256, 1, 1 );
    const playground_mat = new THREE.MeshBasicMaterial( {side: THREE.FrontSide,map:this.textureObjList["playground"],transparent:true,
    depthWrite:false} );
    //plane_mat.wireframe=true;
    this.playground_mesh = new THREE.Mesh( playground_geo, playground_mat );
    this.playground_mesh.name="tgt_playground";
    this.scene.add( this.playground_mesh );


   
    // dom 連携　回転テキスト
    const circleText_geo = new THREE.PlaneGeometry( 1034, 1041, 1, 1 );
    const circleText_mat = new THREE.MeshBasicMaterial( {side: THREE.FrontSide,map:this.textureObjList["circle_text"],transparent:true,depthWrite:false} );//depthWrite:false,
    this.circleText_mesh = new THREE.Mesh( circleText_geo, circleText_mat );
    this.circleText_mesh.name="tgt_circleText";
    this.circleText_mesh.position.x=0;
    this.circleText_mesh.position.y=0;
    this.circleText_mesh.position.z=0;
    this.scene.add( this.circleText_mesh );

    
    this.dotsContainer=new THREE.Object3D();
    this.dotsContainer.name="dotsContainer";
    this.dotsContainer.visible=false;


    //dot
    // カスタムジオメトリオブジェクトをインスタンス化

    // attributes用の配列を生成
    var vertices = [];      // 頂点
    var colors = [];      // 頂点カラー
    this.dotsNumber=100;

    // dotsNumberの数だけドットを生成
    for(var i = 0; i < this.dotsNumber; i++){
      var dotObj={};
      dotObj.sx=Math.random()*6000-3000;
      dotObj.sy=Math.random()*15000-12000;
      dotObj.sz=Math.random()*3000-3000;
      dotObj.px=dotObj.sx;
      dotObj.py=dotObj.sy;
      dotObj.pz=dotObj.sz;
      dotObj.vx=Math.random();
      dotObj.vy=Math.random();
      dotObj.vz=0;
      dotObj.r=20;//100*Math.random();
      this.dotsList.push(dotObj);
      vertices.push(dotObj.sx);  // x
      vertices.push(dotObj.sy);  // y
      vertices.push(dotObj.sz);  // z
    }
    for(var i = 0; i < this.dotsNumber; i++){
      var colorLength=this.colorPalette.length;
      var index=i%colorLength;
      colors.push(this.colorPalette[index].r/255);  // r
      colors.push(this.colorPalette[index].g/255);  // g
      colors.push(this.colorPalette[index].b/255);  // b
      colors.push(1.0);  // alpha
    }

    // attributes
    var positionAttr=new THREE.Float32BufferAttribute(vertices,3);
    var colorsAttr=new THREE.Float32BufferAttribute(colors,4);

    this.dot_geometry = new THREE.BufferGeometry();
    this.dot_geometry.setAttribute('position',     positionAttr);
    this.dot_geometry.setAttribute('colors',     colorsAttr);
    this.dot_geometry.computeBoundingBox();

    // RawShaderMaterial生成
    this.dot_material = new THREE.RawShaderMaterial({

      // 正方形の正面を描画
      side: THREE.FrontSide,
      blending:THREE.NormalBlending,//THREE.NoBlending,THREE.NormalBlending,THREE.AdditiveBlending,THREE.MultiplyBlending
      transparent:true,

      // シェーダに渡すuniform変数の定義
      uniforms: {
        uDotSize: { type: '1f', value: this.paramObj.dotSize },
        uDotAlpha: { type: '1f', value: this.paramObj.dotAlpha },
        uResolution: { type: 'v2', value: new THREE.Vector2( this.wid, this.canvasHeight ) },
      },

      // 頂点シェーダのプログラムをwebpackで読み込んだglsl/dot.vertから取得
      vertexShader: dot_vs,

      // フラグメントシェーダのプログラムをwebpackで読み込んだglsl/dot.fragから取得
      fragmentShader: dot_fs
    });

    var dot_points=new THREE.Points(this.dot_geometry,this.dot_material);
    dot_points.renderOrder=-2;
    dot_points.position.x=0;
    dot_points.position.y=0;
    dot_points.position.z=0;
    dot_points.frustumCulled=false;
    this.dotsContainer.add(dot_points);

    this.scene.add(this.dotsContainer);
    this.scene.add(this.scrollObjContainer);
    this.container.add(this.topContainer);
    this.scene.add(this.container);

    this.container.position.x=0;
    this.container.position.y=0;
    

    /*** レンダラー設定 ***/
    // var canvas = document.getElementById("c-glCanvas");

    this.renderer = new THREE.WebGLRenderer({canvas: this.el,preserveDrawingBuffer: true,logarithmicDepthBuffer: true, "antialias": false, alpha: true,transparent:false });
    this.renderer.setPixelRatio(2);
    this.renderer.autoClearColor = true;//true:clear色で塗りつぶす|false:そのままで軌跡が残る

    this.renderer.setSize(this.wid, this.canvasHeight);
    this.camera.aspect = this.wid / this.canvasHeight;
    this.camera.updateProjectionMatrix();

   

    // 荒井さん
    this.lightsManager = new LightsManager();


    this.scene.add(this.lightsManager.ambientLights[0]);
    this.scene.add(this.lightsManager.directionalLights[0]);

    this.manager = new SimpleThreeManager();
    this.params = {
      manager: this.manager,
      materials: undefined,
      images: {},
      textures: {}
    };

    
    // ---------- Textures
    //aoMapはcanvasで生成
    //bumpMapはpng
    this.texturesManager = new TexturesManager(this.params);
    this.params.textures = this.texturesManager.textures;
    this.params.textures['rough'] = this.textureObjList["rough"];
    this.params.materials = new Materials(this.params);
    
    (async () => {

      await Logo.load();
      await Astronaut.load();
      await Airplane.load();
      await Dinosaur.load();

      this.models = [
        new Logo(this.params,"tgt_logo"),
        new Astronaut(this.params,"tgt_astronaut"),
        new Astronaut(this.params,"scr_lead_astronaut_mesh"),
        new Airplane(this.params,"tgt_plane"),
        new Dinosaur(this.params,"tgt_dinosaur"),
        new Dinosaur(this.params,"scr_lead_dinosaur"),
      ];

      this.models.forEach((model, index) => {

        if(model.mesh.name==="tgt_logo"){
          // ロゴ top center bottom
          this.logo_mesh = model.mesh;//gltf.scene;
          this.logo_mesh.name="tgt_logo";
          this.topContainer.add(this.logo_mesh)
          this.logo_mesh.scale.set(30, 30, 30);
          this.logo_mesh.position.x = 0;
          this.logo_mesh.position.y = -280;
          this.logo_mesh.position.z = 0;

          this.xSetMoveConfig(this.logo_mesh,'logo');
        }else if(model.mesh.name==="tgt_plane"){
          // 飛行機 top center bottom
          this.airplane_mesh = model.mesh;//gltf.scene;
          this.airplane_mesh.name="tgt_plane";
          this.topContainer.add(this.airplane_mesh);
          this.airplane_mesh.scale.set(30, 30, 30);
          this.airplane_mesh.position.x = 60;
          this.airplane_mesh.position.y = 290;
          this.airplane_mesh.position.z = 0;
          this.xSetMoveConfig(this.airplane_mesh,'airplane');
        }else if(model.mesh.name==="tgt_astronaut"){
          // 宇宙飛行士 top center bottom
          this.astronaut_mesh = model.mesh;//gltf.scene;
          this.astronaut_mesh.name="tgt_astronaut";
          this.topContainer.add(this.astronaut_mesh);
          this.astronaut_mesh.scale.set(30, 30, 30);
          this.astronaut_mesh.position.x = 0;
          this.astronaut_mesh.position.y = 0;
          this.astronaut_mesh.position.z = 0;
          this.xSetMoveConfig(this.astronaut_mesh,'astronaut');
        }else if(model.mesh.name==="scr_lead_astronaut_mesh"){
          // 宇宙飛行士 scroll　domパーツで個別設定
          this.lead_astronaut_mesh = model.mesh;//this.astronaut_mesh.clone();
          this.lead_astronaut_mesh.name="scr_lead_astronaut_mesh";
          this.scene.add(this.lead_astronaut_mesh);
          this.lead_astronaut_mesh.scale.set(28, 28, 28);
          this.lead_astronaut_mesh.position.x = 0;
          this.lead_astronaut_mesh.position.y = 0;
          this.lead_astronaut_mesh.position.z = 0;
          this.xSetMoveConfig(this.lead_astronaut_mesh,'astronaut');
        }else if(model.mesh.name==="tgt_dinosaur"){
          // 恐竜 top center bottom
          this.dinosaur_mesh = model.mesh;//gltf.scene;
          this.dinosaur_mesh.name="tgt_dinosaur";
          this.topContainer.add(this.dinosaur_mesh);
          this.dinosaur_mesh.scale.set(30, 30, 30);
          this.dinosaur_mesh.position.x = 340;
          this.dinosaur_mesh.position.y = -120;
          this.dinosaur_mesh.position.z = 10;
          this.xSetMoveConfig(this.dinosaur_mesh,'dinosaur');
        }else if(model.mesh.name==="scr_lead_dinosaur"){
          // 恐竜 lead エリアスクロール
          this.lead_dinosaur_mesh = model.mesh;//this.dinosaur_mesh.clone();
          this.lead_dinosaur_mesh.name="scr_lead_dinosaur";
          this.scrollObjContainer.add(this.lead_dinosaur_mesh);
          this.lead_dinosaur_mesh.scale.set(20, 20, 20);
          this.lead_dinosaur_mesh.position.x = 0;
          this.lead_dinosaur_mesh.position.y = 0;
          this.lead_dinosaur_mesh.position.z = 0;
          this.xSetMoveConfig(this.lead_dinosaur_mesh,'dinosaur');
          //scr
          var scr_lead_dinosaur={
            name:"scr_lead_dinosaur",
            mesh:this.lead_dinosaur_mesh,
            area:"lead",
            x:0.1,
            y:0.9,
            z:0,
            scale:20
          }
          this.scrollObjList.push(scr_lead_dinosaur);
        }else{
          model.mesh.position.x = (index - 1.5) * 10;
          model.mesh.rotation.order = 'YZX'
          model.mesh.rotation.x = 90 * DEG2RAD;
          this.topContainer.add(model.mesh);
        }

      });

      // GLB準備完了

      for(var i = 0; i < this.scrollObjList.length; i++){
        var scrollObj=this.scrollObjList[i];
        var scrollObjMesh=scrollObj.mesh;
        scrollObjMesh.scale.set(1,1,1);
        scrollObjMesh.position.set(0,0,0);
        var scrollObjHolder=new THREE.Object3D();
        scrollObjHolder.name=scrollObj.name+"_holder";
        scrollObjHolder.add(scrollObjMesh);
        this.scrollObjContainer.add(scrollObjHolder);
        //_childは周期運動＆scaleセット固定
        //meshはholder内自由移動＆scale任意
        //_holderはスクロールエリアで位置相対固定
      }



      this.isGlbModelsLoaded=true;
      this.onLoadedCheck();

    })();

    //move 初期設定
    this.move.manager = this.params.manager;
    this.move.materials = this.params.materials;

    // RING
    const ringsArray=[
      {colorNum:2,x:100,y:0,name:"tgt_ring1"},
      {colorNum:1,x:-100,y:0,name:"tgt_ring2"},//太RING
      {colorNum:2,x:100,y:0,name:"scr_casestudy_ring"},
      {colorNum:2,x:100,y:0,name:"scr_value_ring"},
      {colorNum:2,x:100,y:0,name:"scr_company_ring"},
    ];
    this.rings=new Rings(this.params,ringsArray);
    this.topContainer.add(this.rings.meshes[0]);
    this.topContainer.add(this.rings.meshes[1]);
    this.xSetMoveConfig(this.rings.meshes[0],"ring");
    this.xSetMoveConfig(this.rings.meshes[1],"ring2");

    //scr_casestudy_ring
    this.scrollObjContainer.add(this.rings.meshes[2]);//scr_casestudy_ring
    var scr_casestudy_ring={
      name:"scr_casestudy_ring",
      mesh:this.rings.meshes[2],
      area:"casestudy",
      x:0.3,
      y:0.95,
      z:200,
      scale:0.8
    }
    this.rings.meshes[2].position.z=0;
    this.scrollObjList.push(scr_casestudy_ring);

    //scr_company_ring
    this.scrollObjContainer.add(this.rings.meshes[4]);//scr_company_ring
    var scr_company_ring={
      name:"scr_company_ring",
      mesh:this.rings.meshes[4],
      area:"company",
      x:0.9,
      y:0.25,
      z:-200,
      scale:0.9
    }
    this.rings.meshes[4].position.z=0;
    this.scrollObjList.push(scr_company_ring);

    this.xSetMoveConfig(this.rings.meshes[2],"ring3");
    this.xSetMoveConfig(this.rings.meshes[3],"ring2");
    this.xSetMoveConfig(this.rings.meshes[4],"ring");


    // 半円RING
    const halfRingsArray=[
      {colorNum:4,x:200,y:0,name:"tgt_halfRing1"},
      {colorNum:4,x:-200,y:0,name:"tgt_halfRing2"},
      {colorNum:4,x:0,y:0,name:"scr_what_halfRing"},//scr_what_halfRing
      {colorNum:4,x:0,y:0,name:"scr_casestudy_halfRing"},//scr_casestudy_halfRing
      {colorNum:4,x:0,y:0,name:"scr_about_halfRing"},//scr_about_halfRing
      {colorNum:4,x:0,y:0,name:"scr_value_halfRing"}//scr_value_halfRing
    ];
    this.halfRings=new HalfRings(this.params,halfRingsArray);
    this.topContainer.add(this.halfRings.meshes[0]);
    this.topContainer.add(this.halfRings.meshes[1]);
    this.xSetMoveConfig(this.halfRings.meshes[0],"halfRingRight");
    this.xSetMoveConfig(this.halfRings.meshes[1],"halfRingLeft");

    //scr_what_halfRing
    this.scrollObjContainer.add(this.halfRings.meshes[2]);//scr_what_halfRing
    var scr_what_halfRing={
      name:"scr_what_halfRing",
      mesh:this.halfRings.meshes[2],
      area:"what",
      x:0.2,
      y:0.65,
      z:0,
      scale:1,
      in:false,
    }
    this.scrollObjList.push(scr_what_halfRing);

    //scr_casestudy_halfRing
    this.scrollObjContainer.add(this.halfRings.meshes[3]);//scr_casestudy_halfRing
    var scr_casestudy_halfRing={
      name:"scr_casestudy_halfRing",
      mesh:this.halfRings.meshes[3],
      area:"casestudy",
      x:0.05,
      y:0.45,
      z:0,
      scale:0.8
    }
    this.scrollObjList.push(scr_casestudy_halfRing);


    this.xSetMoveConfig(this.halfRings.meshes[2],"halfRingLeft2");
    this.xSetMoveConfig(this.halfRings.meshes[3],"halfRingLeft");


    // 球体
    const spheresArray=[
      {colorNum:4,x:300,y:0,name:"tgt_sphere1"},
      {colorNum:0,x:-300,y:0,name:"tgt_sphere2"},
      {colorNum:1,x:-300,y:-100,name:"tgt_sphere3"},
      {colorNum:4,x:0,y:0,name:"scr_lead_sphere"},
      {colorNum:4,x:0,y:0,name:"scr_about_sphere"},
      {colorNum:0,x:0,y:0,name:"scr_value_sphere"},
    ];
    this.spheres=new Spheres(this.params,spheresArray);
    this.topContainer.add(this.spheres.meshes[0]);
    this.topContainer.add(this.spheres.meshes[1]);
    this.topContainer.add(this.spheres.meshes[2]);
    this.xSetMoveConfig(this.spheres.meshes[0],"sphere");
    this.xSetMoveConfig(this.spheres.meshes[1],"sphere");
    this.xSetMoveConfig(this.spheres.meshes[2],"sphere");


    //scr_lead_sphere
    this.scrollObjContainer.add(this.spheres.meshes[3]);
    var scr_lead_sphere={
      name:"scr_lead_sphere",
      mesh:this.spheres.meshes[3],
      area:"lead",
      x:0.9,
      y:0.25,
      z:0,
      scale:0.9
    }
    this.scrollObjList.push(scr_lead_sphere);

    this.xSetMoveConfig(this.spheres.meshes[3],"sphere");

    //BOX
    const boxesArray=[
      {colorNum:1,x:0,y:0,name:"tgt_box1"},
      {colorNum:1,x:0,y:0,name:"scr_lead_box"},
      {colorNum:1,x:0,y:0,name:"scr_casestudy_box"},
      {colorNum:1,x:0,y:0,name:"scr_company_box"},
    ];
    this.boxes=new Boxes(this.params,boxesArray);
    this.topContainer.add(this.boxes.meshes[0]);
    this.xSetMoveConfig(this.boxes.meshes[0],"box");
    this.xSetMoveConfig(this.boxes.meshes[1],"box");
    this.xSetMoveConfig(this.boxes.meshes[2],"box");
    this.xSetMoveConfig(this.boxes.meshes[3],"box");

    //scr_lead_box
    this.scrollObjContainer.add(this.boxes.meshes[1]);
    var scr_lead_box={
      name:"scr_lead_box",
      mesh:this.boxes.meshes[1],
      area:"lead",
      x:0.75,
      x_sp:0.9,
      y:0.8,
      y_sp:0.6,
      z:0,
      scale:1,
      in:true
    }
    this.scrollObjList.push(scr_lead_box);

    //scr_casestudy_box
    this.scrollObjContainer.add(this.boxes.meshes[2]);
    var scr_casestudy_box={
      name:"scr_casestudy_box",
      mesh:this.boxes.meshes[2],
      area:"casestudy",
      x:0.8,
      y:0.2,
      z:200,
      scale:0.8,
      in:false,
    }
    this.boxes.meshes[2].position.z=0;
    this.scrollObjList.push(scr_casestudy_box);

    //scr_company_box
    this.scrollObjContainer.add(this.boxes.meshes[3]);
    var scr_company_box={
      name:"scr_company_box",
      mesh:this.boxes.meshes[3],
      area:"company",
      x:0.7,
      y:1,
      z:100,
      scale:0.8,
      in:true,
    }
    this.boxes.meshes[3].position.z=0;
    this.scrollObjList.push(scr_company_box);



    //Pyramid
    const pyramidsArray=[
      {colorNum:0,x:400,y:0,name:"tgt_pyramid1"},//オレンジ
      {colorNum:0,x:-400,y:50,name:"tgt_pyramid2"},//オレンジ
      {colorNum:1,x:0,y:200,name:"tgt_pyramid3"},//ピンク　ミニ
      {colorNum:0,x:0,y:0,name:"scr_lead_pyramid"},//オレンジ
      {colorNum:0,x:0,y:0,name:"scr_what_pyramid"},//オレンジ
      {colorNum:1,x:0,y:0,name:"scr_value_pyramid"},//ピンク　ミニ
    ];
    this.pyramids=new Pyramids(this.params,pyramidsArray);
    this.topContainer.add(this.pyramids.meshes[0]);
    this.topContainer.add(this.pyramids.meshes[1]);
    this.topContainer.add(this.pyramids.meshes[2]);
    this.xSetMoveConfig(this.pyramids.meshes[0],"pyramid1");
    this.xSetMoveConfig(this.pyramids.meshes[1],"pyramid1");
    this.xSetMoveConfig(this.pyramids.meshes[2],"pyramid2");
    this.xSetMoveConfig(this.pyramids.meshes[3],"pyramid1");
    this.xSetMoveConfig(this.pyramids.meshes[4],"pyramid1");
    // this.xSetMoveConfig(this.pyramids.meshes[5],"pyramid2");

    //scr_lead
    this.scrollObjContainer.add(this.pyramids.meshes[3]);
    var scr_lead_pyramid={
      name:"scr_lead_pyramid",
      mesh:this.pyramids.meshes[3],
      area:"lead",
      x:0.15,
      y:0.3,
      z:0,
      scale:1,
      in:true
    }
    this.scrollObjList.push(scr_lead_pyramid);

    //scr_what
    this.scrollObjContainer.add(this.pyramids.meshes[4]);
    var scr_what_pyramid={
      name:"scr_what_pyramid",
      mesh:this.pyramids.meshes[4],
      area:"what",
      x:0.6,
      y:0.9,
      z:0,
      scale:0.6
    }
    this.scrollObjList.push(scr_what_pyramid);

    //Cone
    const conesArray=[
      {colorNum:2,x:400,y:0,name:"tgt_cone1"},//マゼンタ
      {colorNum:3,x:-400,y:50,name:"tgt_cone2"},//RED
      {colorNum:3,x:0,y:50,name:"scr_casestudy_cone"},//RED
      {colorNum:3,x:0,y:0,name:"scr_value_cone"},//RED
      {colorNum:3,x:0,y:0,name:"scr_company_cone"},//RED
    ];
    this.cones=new Cones(this.params,conesArray);
    this.topContainer.add(this.cones.meshes[0]);
    this.topContainer.add(this.cones.meshes[1]);
    this.xSetMoveConfig(this.cones.meshes[0],"cone");
    this.xSetMoveConfig(this.cones.meshes[1],"cone");
    this.xSetMoveConfig(this.cones.meshes[2],"cone");
    this.xSetMoveConfig(this.cones.meshes[4],"cone");

    //scr_casestudy_cone
    this.scrollObjContainer.add(this.cones.meshes[2]);
    var scr_casestudy_cone={
      name:"scr_casestudy_cone",
      mesh:this.cones.meshes[2],
      area:"casestudy",
      x:0.45,
      y:0.2,
      z:200,
      scale:0.9
    }
    this.cones.meshes[2].position.z=0;
    this.scrollObjList.push(scr_casestudy_cone);

    //scr_company_cone
    this.scrollObjContainer.add(this.cones.meshes[4]);
    var scr_company_cone={
      name:"scr_company_cone",
      mesh:this.cones.meshes[4],
      area:"company",
      x:0.1,
      y:0.6,
      z:0,
      scale:0.8,
      in:true,
    }
    this.cones.meshes[4].position.z=0;
    this.scrollObjList.push(scr_company_cone);



    //Coin
    const coinsArray=[
      {colorNum:5,x:0,y:-100,name:"tgt_coin1"},//青
      {colorNum:5,x:0,y:0,name:"scr_about_coin"},//青
      {colorNum:5,x:0,y:0,name:"scr_company_coin"},//青
    ];
    this.coins=new Coins(this.params,coinsArray);
    this.topContainer.add(this.coins.meshes[0]);
    this.xSetMoveConfig(this.coins.meshes[0],"coin");
    this.xSetMoveConfig(this.coins.meshes[2],"coin");

    //scr_company_coin
    this.scrollObjContainer.add(this.coins.meshes[2]);
    var scr_company_coin={
      name:"scr_company_coin",
      mesh:this.coins.meshes[2],
      area:"company",
      x:0.1,
      y:0.0,
      z:0,
      scale:0.5,
      in:true,
    }
    this.coins.meshes[2].position.z=0;
    this.scrollObjList.push(scr_company_coin);


    //Cube
    const cubeArray=[
      {colorNum:0,x:50,y:-300,name:"tgt_cube1"},//オレンジ
      {colorNum:0,x:0,y:0,name:"scr_ticker_cube"},//オレンジ
      {colorNum:0,x:0,y:0,name:"scr_about_cube"},//オレンジ
      {colorNum:0,x:0,y:0,name:"scr_value_cube"},//オレンジ
    ];
    this.cubes=new Cubes(this.params,cubeArray);
    this.topContainer.add(this.cubes.meshes[0]);
    this.xSetMoveConfig(this.cubes.meshes[0],"cube");
    this.xSetMoveConfig(this.cubes.meshes[1],"cube");

    // scr_ticker_cube
    this.scrollObjContainer.add(this.cubes.meshes[1]);
    var scr_ticker_cube={
      name:"scr_ticker_cube",
      mesh:this.cubes.meshes[1],
      area:"ticker",
      x:0.7,
      y:0.6,
      z:30,
      scale:1.0
    }
    this.cubes.meshes[1].position.z=0;
    this.scrollObjList.push(scr_ticker_cube);
    

    Dumplings.init();
    //Dumplings
    const dumplingsArray=[
      {colorNum:0,x:0,y:0,name:"tgt_dumplings"},
    ];
    this.dumplings = new Dumplings(this.params,dumplingsArray);
    this.topContainer.add(this.dumplings.mesh);
    this.xSetMoveConfig(this.dumplings.mesh,"dumplings");

    this.dumplings.mesh.children[0].scale.set(1,1,1);

    //canvasセット完了
  }

  /** 
   * オープニング前の位置にセットします
   */
   xSetPreOpening(){
    this.status="pre";
    var tgtList;
    if(this.breakPoint==="pc"){
      tgtList=this.pre_pc;
    }else if(this.breakPoint==="tab"){
      tgtList=this.pre_tab;
    }else if(this.breakPoint==="sp"){
      tgtList=this.pre_sp;
    }

    
    //周辺に配置
    for(var i = 0; i < tgtList.length; i++){
      var obj=tgtList[i];
      var tgtMesh=this.xGetMesh(obj.name);
      gsap.killTweensOf(tgtMesh.position);
      gsap.killTweensOf(tgtMesh.scale);
      
      if(obj.name.indexOf("planeTop")>-1){
        tgtMesh.visible=true;
        gsap.set(tgtMesh.position,{x:obj.x,y:obj.y,z:obj.z});
        gsap.set(tgtMesh.scale,{x:obj.sX,y:obj.sY,z:obj.sZ});
      }else{
        var dist=Math.max(this.wid,this.hei)*5;      
        var rad=Math.atan2(obj.y,obj.x);
        var px=dist*Math.cos(rad);
        var py=dist*Math.sin(rad);
        
        gsap.set(tgtMesh.position,{x:px,y:py,z:0});

        tgtMesh.visible=obj.visible;
      }
    }


    //初期ロード完了後実行待ち状態
    if(this.breakPoint==="sp"){
      this.container.position.x=-17;
      this.container.position.y=0;
      this.container.position.z=1350;
      this.container.rotation.x=0;
      this.container.rotation.y=0.6981317;
      this.container.rotation.z=0;
    }else{
      this.container.position.x=-17;
      this.container.position.y=0;
      this.container.position.z=1350;
      this.container.rotation.x=0;
      this.container.rotation.y=0.6981317;
      this.container.rotation.z=0;
    }

    this.topContainer.rotation.x=Math.PI*this.paramObj.topStartRoteX;
    this.topContainer.rotation.y=-Math.PI*this.paramObj.topStartRoteY;
    this.topContainer.rotation.z=Math.PI*this.paramObj.topStartRoteZ;
    this.topContainer.position.z=1000;

    this.dot_material.uniforms.uDotAlpha.value=0.0;
    
  }


  /** 
   * オープニングを開始します
   */
  startOpening(){
    this.xSetPreOpening();
    this.status="opening";
    if(!this.isReady){
      return;
    }

    let durationTime=1.8;
    let delayTime=0.06;
    const easing="power4.out";

    var tgtList;
    if(this.breakPoint==="pc"){
      tgtList=this.top_pc;
    }else if(this.breakPoint==="tab"){
      tgtList=this.top_tab;
    }else if(this.breakPoint==="sp"){
      tgtList=this.top_sp;
    }
    
    //周辺に配置

    var curvePoint=this.paramObj.curvePoint;
    if(this.breakPoint!=="pc"){
      curvePoint=this.paramObj.curvePoint*0.3;
    }

    for(var i = 0; i < tgtList.length; i++){
      var obj=tgtList[i];
      var tgtMesh=this.xGetMesh(obj.name);
      if(tgtMesh){
        gsap.killTweensOf(tgtMesh.position);
        gsap.killTweensOf(tgtMesh.scale);

        var dist=Math.max(this.wid,this.hei);      
        var rad=Math.atan2(obj.y,obj.x);
        var px=dist*Math.cos(rad);
        var py=dist*Math.sin(rad);
        var px2=dist*0.5*Math.cos(rad);//+Math.random()*50-25;
        var py2=dist*0.5*Math.sin(rad)-curvePoint;
        
        const anchorsTop = [{x:px, y:py}, {x:px2, y:py2}, {x:obj.x, y:obj.y}];
        const rawPathTop = MotionPathPlugin.arrayToRawPath(anchorsTop, {curviness:this.paramObj.curviness});
        const pathTop = MotionPathPlugin.rawPathToString( rawPathTop );

        tgtMesh.visible=obj.visible;
        if(obj.name.indexOf("planeTop")>-1){
          gsap.to(tgtMesh.position,{duration:durationTime,z:obj.z,x:obj.x, y:obj.y,ease:"power4.out",delay:0});
          gsap.to(tgtMesh.scale,{duration:durationTime,x:obj.sX,y:obj.sY,z:obj.sZ,ease:"power4.out",delay:0});
          gsap.to(tgtMesh.rotation,{duration:durationTime,x:obj.rX,y:obj.rY,z:obj.rZ,ease:"power4.out",delay:0});
        }else{
          gsap.to(tgtMesh.position,{duration:durationTime,z:obj.z,//x:obj.x, y:obj.y,
            motionPath: {
              path: pathTop,
              autoRotate: true
            },
            ease:"power4.out",delay:i*delayTime});
          gsap.to(tgtMesh.scale,{duration:durationTime,x:obj.sX,y:obj.sY,z:obj.sZ,ease:"power4.out",delay:i*delayTime});
          gsap.to(tgtMesh.rotation,{duration:durationTime,x:obj.rX,y:obj.rY,z:obj.rZ,ease:"power4.out",delay:i*delayTime});
        }
      }
    }

    gsap.killTweensOf(this.container.position);
    gsap.killTweensOf(this.container.rotation);
    gsap.killTweensOf(this.topContainer.position);
    gsap.killTweensOf(this.topContainer.rotation);
    
    this.dotsContainer.visible=true;
    this.dot_material.uniforms.uDotAlpha.value=0.0;
    gsap.to(this.dot_material.uniforms.uDotAlpha,{duration:1.5,value:1,ease:Quad.easeOut,delay:0.8});

    gsap.to(this.container.position,{duration:1.6,delay:0,x:0,y:0,z:0,ease:"power4.out"});
    gsap.to(this.container.rotation,{duration:1.6,delay:0,x:0,y:0,z:0,ease:"power4.out",onComplete:this.onOpeningFinished.bind(this)});
    gsap.to(this.topContainer.position,{duration:2.4,delay:0.4,x:0,y:0,z:0,ease:"power4.out"});
    gsap.to(this.topContainer.rotation,{duration:3.6,delay:0.4,x:0,y:0,z:0,ease:"power4.out"});
    
  }


  onOpeningFinished(){
    this.status="top";
    this.isStart=true;
  }


  /** 
   * 動きの設定をセットします
   */
  xSetMoveConfig($mesh,$type){
    
    const config= this.CONFIGS.find(item => item.type === $type);

    const mesh = $mesh;
    
    const mesh_child=$mesh.children[0];

    config.position= new THREE.Vector3();//childのpositionは初期0とする
    mesh_child.position.copy(config.position);

    if (!config.scale) config.scale = new THREE.Vector3(1, 1, 1);
    mesh_child.scale.copy(config.scale);

    if (!config.rotation) config.rotation = new THREE.Euler();
    mesh_child.rotation.set(
        config.rotation.x * DEG2RAD,
        config.rotation.y * DEG2RAD,
        config.rotation.z * DEG2RAD
    );

    if (config.rotationOrder) mesh_child.rotation.order = config.rotationOrder;

    // 上下運動は一部を除いて共通
    if (!config.loops) config.loops = [];
    if (!config.loops.some(c => c.target === 'position' && c.axis === 'y')) {
        config.loops.push({
            target: 'position',
            axis: 'y',
            distance: 10,
            degrees: 1
        });
    }



    const moveObj={
      config:config,
      mesh:mesh,
      mesh_child:mesh_child,
      position: new THREE.Vector3(),
      rotation: new THREE.Euler(),
      index:this.move.index,
      positionDegrees:new THREE.Vector3(0, (this.move.index / 30) * 45, 0),//位相ずらし
      scaleDegrees:config.scaleDegrees || 0,
      rotationDegrees:config.rotationDegrees || new THREE.Vector3()
    }

    this.moveList.push(moveObj);

    this.move.index++;
  }



  /** 
   * 繰り返し処理
   */
  onEnter(){
    this.counter++;

    if(this.breakPoint==="pc"){
      //mouseChaser
      var difX=this.mouseClientX-this.mouseChaser.x;
      var difY=this.mouseClientY-this.mouseChaser.y;
      var difT=Math.sqrt(difX*difX+difY*difY)/100;
      this.mouseChaserDiff=difT;
      this.mouseChaser.x+=difX*0.0215;//追従スピード調整
      this.mouseChaser.y+=difY*0.0215;//追従スピード調整

      const mouseChaserX = (this.mouseChaser.x / window.innerWidth) * 2 - 1;
      const mouseChaserY = -(this.mouseChaser.y / window.innerHeight) * 2 + 1;

      this.dotsContainer.position.x=mouseChaserX*-60;
      this.container.position.x=mouseChaserX*-30;
    }else{
      this.container.position.x=0;
    }
      

      // TICKERテキスト スクロール連動
      const tickerTextRect = this.domTickerText.getBoundingClientRect();
      const tickerTextX = tickerTextRect.x-this.centerX+tickerTextRect.width*0.5;
      const tickerTextY = this.centerY-tickerTextRect.y-tickerTextRect.height*0.5;

      if(this.tickerText_mesh){
        this.tickerText_mesh.position.x=tickerTextX;
        this.tickerText_mesh.position.y=tickerTextY;
        this.tickerText_mesh.scale.x=tickerTextRect.height/130;
        this.tickerText_mesh.scale.y=tickerTextRect.height/130;
        this.tickerText_mesh.material.uniforms.uOffsetX.value+=0.001;
      }


      // PLAYGROUND スクロール連動
      if(this.playground_mesh){
        this.playground_mesh.position.x=tickerTextX+5;
        this.playground_mesh.position.y=tickerTextY+40;
        this.playground_mesh.rotation.z=30/180*Math.PI*Math.sin(this.counter*0.01);
        if(this.breakPoint==="pc"){
          this.playground_mesh.scale.set(1, 1, 1);
          this.playground_mesh.position.y=tickerTextY+40;
        }else if(this.breakPoint==="tab"){
          this.playground_mesh.scale.set(0.8, 0.8, 0.8);
          this.playground_mesh.position.y=tickerTextY+20;
        }else if(this.breakPoint==="sp"){
          this.playground_mesh.scale.set(0.6, 0.6, 0.6);
          this.playground_mesh.position.y=tickerTextY+20;
        }
      }

      // 宇宙飛行士 スクロール連動
      if(this.lead_astronaut_mesh){
        this.lead_astronaut_mesh.position.x=0;

        if(this.breakPoint==="pc"){
          this.lead_astronaut_mesh.scale.set(1100*26/1100, 1100*26/1100, 1100*26/1100);
          this.lead_astronaut_mesh.position.y=this.centerY-tickerTextRect.y-60;
          this.lead_astronaut_mesh.position.z=50;
        }else if(this.breakPoint==="tab"){
          this.lead_astronaut_mesh.scale.set(800*26/1100, 800*26/1100, 800*26/1100);
          this.lead_astronaut_mesh.position.y=this.centerY-tickerTextRect.y-40;
          this.lead_astronaut_mesh.position.z=50;
        }else if(this.breakPoint==="sp"){
          this.lead_astronaut_mesh.scale.set(500*26/1100, 500*26/1100, 500*26/1100);
          this.lead_astronaut_mesh.position.y=this.centerY-tickerTextRect.y-40;
          this.lead_astronaut_mesh.position.z=50;
        }
        
      }

      // 回転テキスト スクロール連動
      const circleTextRect = this.domCircleText.getBoundingClientRect();
      const circleTextX = circleTextRect.x-this.centerX+circleTextRect.width*0.5;
      const circleTextY = this.centerY-circleTextRect.y-circleTextRect.height*0.5;

      if(this.circleText_mesh){
        this.circleText_mesh.position.x=circleTextX;
        this.circleText_mesh.position.y=circleTextY;
        this.circleText_mesh.scale.x=circleTextRect.width/1034;
        this.circleText_mesh.scale.y=circleTextRect.height/1041;
        this.circleText_mesh.rotation.z=this.counter*0.003;
      }

      const cContainerRect = this.domCContainer.getBoundingClientRect();
      this.st=cContainerRect.y;

      // dotPoints scroll
      var diffY=-this.st*this.paramObj.dotScroll-this.dotsContainer.position.y
      this.dotsContainer.position.y+=diffY*this.interScroll;

      //ピンクBG スクロール連動
      const domPlanePinkRect = this.domPlanePink.getBoundingClientRect();
      const planePinkX = domPlanePinkRect.x-this.centerX+domPlanePinkRect.width*0.5;
      const planePinkY = this.centerY-domPlanePinkRect.y-domPlanePinkRect.height*0.5;

      if(this.planePink_mesh){
        this.planePink_mesh.position.x=planePinkX;
        this.planePink_mesh.position.y=planePinkY;
        this.planePink_mesh.scale.x=domPlanePinkRect.width/450;
        this.planePink_mesh.scale.y=domPlanePinkRect.height/510;
      }

      
      //ブルーBG スクロール連動
      const domPlaneBlueRect = this.domPlaneBlue.getBoundingClientRect();
      const planeBlueX = domPlaneBlueRect.x-this.centerX+domPlaneBlueRect.width*0.5;
      const planeBlueY = this.centerY-domPlaneBlueRect.y-domPlaneBlueRect.height*0.5;

      if(this.planeBlue_mesh){
        this.planeBlue_mesh.position.x=planeBlueX;
        var diffY=planeBlueY-this.planeBlue_mesh.position.y
        this.planeBlue_mesh.position.y+=diffY*this.interScroll;
        this.planeBlue_mesh.scale.x=domPlaneBlueRect.width/412;
        this.planeBlue_mesh.scale.y=domPlaneBlueRect.height/510;
      }

      // BOTTOM用 FOOTER基準
      const cFooter = document.getElementById("c-footer");
      const cFooterRect = cFooter.getBoundingClientRect();
      
      const bottomOffset=340+400*this.hei/860;

      let tgtY=0;
      if(cFooterRect.y<this.hei*1.5){
        this.xGatherBottom();
        tgtY=(-cFooterRect.y+bottomOffset)*this.paramObj.mainScroll;
      }else if(cFooterRect.y<this.hei*3){
        tgtY=(-cFooterRect.y+bottomOffset)*this.paramObj.mainScroll;
        this.xScatterRandom();
      }else if(this.st<-100){
        tgtY=-this.st*this.paramObj.mainScroll;
      }else if(this.st>-1200){
        this.xGatherTop();
        tgtY=-this.st*this.paramObj.mainScroll;
      }else{
        this.xScatterRandom();
        tgtY=-this.st*this.paramObj.mainScroll;
      }
      
      
      var diffY= tgtY-this.container.position.y;
      this.container.position.y+=diffY*this.interScroll;
      
      // WHAT BG スクロール連動
      const domWhatBg = document.getElementById("p-top__whatBg");
      const domWhatBgRect = domWhatBg.getBoundingClientRect();
      const whatBgX = domWhatBgRect.x-this.centerX+domWhatBgRect.width*0.5;
      const whatBgY = this.centerY-domWhatBgRect.y-domWhatBgRect.height*0.5;

      if(this.whatBg_mesh){
        if(this.breakPoint=="pc"){
          this.whatBg_mesh.scale.set(domWhatBgRect.width,domWhatBgRect.height-82,1);
          this.whatBg_mesh.position.x=whatBgX;
          this.whatBg_mesh.position.y=whatBgY+41;
          this.whatBg_mesh.position.z=0;
        }else if(this.breakPoint=="tab"){
          this.whatBg_mesh.scale.set(domWhatBgRect.width,domWhatBgRect.height-40,1);
          this.whatBg_mesh.position.x=whatBgX;
          var diffY=whatBgY+20-this.whatBg_mesh.position.y;
          this.whatBg_mesh.position.y+=diffY*this.interScroll;
          this.whatBg_mesh.position.z=0;

        }else if(this.breakPoint=="sp"){
          this.whatBg_mesh.scale.set(domWhatBgRect.width,domWhatBgRect.height-40,1);
          this.whatBg_mesh.position.x=whatBgX;
          var diffY=whatBgY+20-this.whatBg_mesh.position.y;
          this.whatBg_mesh.position.y+=diffY*this.interScroll;
          this.whatBg_mesh.position.z=0;
        }
      }



      //画面連動スクロールオブジェクト

      const domArea_lead_rect = this.domArea_lead.getBoundingClientRect();
      const domArea_leadX = domArea_lead_rect.x-this.centerX;
      const domArea_leadY = this.centerY-domArea_lead_rect.y;

      const domArea_ticker_rect = this.domArea_ticker.getBoundingClientRect();
      const domArea_tickerX = domArea_ticker_rect.x-this.centerX;
      const domArea_tickerY = this.centerY-domArea_ticker_rect.y;

      const domArea_what_rect = this.domArea_what.getBoundingClientRect();
      const domArea_whatX = domArea_what_rect.x-this.centerX;
      const domArea_whatY = this.centerY-domArea_what_rect.y;

      const domArea_casestudy_rect = this.domArea_casestudy.getBoundingClientRect();
      const domArea_casestudyX = domArea_casestudy_rect.x-this.centerX;
      const domArea_casestudyY = this.centerY-domArea_casestudy_rect.y;

      const domArea_company_rect = this.domArea_company.getBoundingClientRect();
      const domArea_companyX = domArea_company_rect.x-this.centerX;
      const domArea_companyY = this.centerY-domArea_company_rect.y;

      this.rectList["lead"].rect=domArea_lead_rect;
      this.rectList["lead"].x0=domArea_leadX;
      this.rectList["lead"].y0=domArea_leadY;
      this.rectList["ticker"].rect=domArea_ticker_rect;
      this.rectList["ticker"].x0=domArea_tickerX;
      this.rectList["ticker"].y0=domArea_tickerY;
      this.rectList["what"].rect=domArea_what_rect;
      this.rectList["what"].x0=domArea_whatX;
      this.rectList["what"].y0=domArea_whatY;
      this.rectList["casestudy"].rect=domArea_casestudy_rect;
      this.rectList["casestudy"].x0=domArea_casestudyX;
      this.rectList["casestudy"].y0=domArea_casestudyY;
      this.rectList["company"].rect=domArea_company_rect;
      this.rectList["company"].x0=domArea_companyX;
      this.rectList["company"].y0=domArea_companyY;


      // スクロールOBJECT 相対配置
      const length=this.scrollObjList.length;
      var times=1;
      if(this.wid<=500){
        times=0.5;
      }else if(this.wid<=900){
        times=0.75;
      }
      for(var i = 0; i < length; i++){
        const scrObj=this.scrollObjList[i];
        var px=scrObj.x;
        var py=scrObj.y;
        if(times===0.5){
          if(scrObj.x_sp){
            px=scrObj.x_sp;
          }
          if(scrObj.y_sp){
            py=scrObj.y_sp;
          }
        }
        
        if(scrObj.mesh){
          if(scrObj.in){
            if(scrObj.mesh.parent.position.y>-this.hei*0.5&&scrObj.mesh.parent.position.y!==0){
              scrObj.in=false;
              gsap.set(scrObj.mesh.position,{y:0});
                if(scrObj.x<0.5){
                  gsap.to(scrObj.mesh.position,{duration:2,//x:0,y:0,
                    motionPath: {
                      path: this.pathLeft,
                      autoRotate: true
                    },
                    ease:"power4.out",delay:0.2});
                }else{
                  gsap.to(scrObj.mesh.position,{duration:2,//x:0,y:0,
                    motionPath: {
                      path: this.pathRight,
                      autoRotate: true
                    },
                    ease:"power4.out",delay:0.2});
                }
            }else{
              if(scrObj.x<0.5){
                scrObj.mesh.position.x=-this.wid*0.6;
              }else{
                scrObj.mesh.position.x=+this.wid*0.6;
              }
            }
            
          }

          scrObj.mesh.parent.position.x=this.rectList[scrObj.area].x0+px*this.rectList[scrObj.area].rect.width;
          var tgtObjY=(this.rectList[scrObj.area].y0-py*this.rectList[scrObj.area].rect.height)*this.paramObj.subScroll;
          var diffTgtObjY=tgtObjY-scrObj.mesh.parent.position.y;
          scrObj.mesh.parent.position.y+=diffTgtObjY*this.interScroll;

          if(scrObj.scaleY){
            scrObj.mesh.children[0].scale.set(scrObj.scale*times,scrObj.scaleY*times,scrObj.scale*times);
          }else{
            scrObj.mesh.children[0].scale.set(scrObj.scale*times,scrObj.scale*times,scrObj.scale*times);
          }
        }
      }


      // dot point cloud
      for(var i = 0; i < this.dotsNumber; i++){
        var dotObj=this.dotsList[i];

        dotObj.px=dotObj.sx+this.paramObj.dotMoveArea*Math.cos(this.counter*dotObj.vx*this.paramObj.dotSpeed*0.001);
        dotObj.py=dotObj.sy+this.paramObj.dotMoveArea*Math.sin(this.counter*dotObj.vy*this.paramObj.dotSpeed*0.001);
        dotObj.pz=dotObj.sz*this.paramObj.dotZ+this.paramObj.dotMoveArea*Math.sin(this.counter*dotObj.vz*this.paramObj.dotSpeed*0.001);
        
        this.dot_geometry.attributes.position.setX(i, dotObj.px);//4or3注意
        this.dot_geometry.attributes.position.setY(i, dotObj.py);
        this.dot_geometry.attributes.position.setZ(i, dotObj.pz);
      }

      this.dot_geometry.attributes.position.needsUpdate = true;

    
      for (let i = 0; i < this.moveList.length; i++) {
        const moveObj=this.moveList[i];
        const config = moveObj.config;//対応するtypeのconfig

        // 差分値
        const position = moveObj.position;
        const rotation = moveObj.rotation;

        // ------------------------------ Loops
        config.loops.forEach((loop) => {

            let degrees, deg;

            switch (loop.target) {

                // ------------------------------ Scale は使用しない
                // case 'scale':
                //     // type = sine のみ
                //     // axis 指定なし
                //     deg = this.scaleDegrees[i] += loop.degrees;
                //     const s = Math.pow(2, Math.sin(deg * DEG2RAD) * loop.distance);
                //
                //     this.meshes[i].scale.set(s, s, s);
                //
                //     break;

                // ------------------------------ Position
                case 'position':

                    // type = sine のみ
                    degrees = moveObj.positionDegrees;
                    deg = degrees[loop.axis] += loop.degrees * this.move.speed;
                    position[loop.axis] = Math.sin(deg * DEG2RAD) * loop.distance/moveObj.mesh.scale.x;
                    break;

                // ------------------------------ Rotation
                // 同じ軸に対して add と sine を同時に使用できないので注意
                case 'rotation':

                    switch (loop.type) {
                        case 'add':
                            rotation[loop.axis] += loop.delta * this.move.speed;
                            break;

                        case 'sine':
                            const degrees = moveObj.rotationDegrees;
                            const deg = degrees[loop.axis] += loop.degrees * this.move.speed;
                            rotation[loop.axis] = Math.sin(deg * DEG2RAD) * loop.distance;///moveObj.mesh.scale.x
                            break;
                    }

                    break;

            }

        });

        // 基準値 + 差分値
        moveObj.mesh.children[0].position.copy(config.position).add(position);
        moveObj.mesh.children[0].rotation.set(
            (config.rotation.x + rotation.x) * DEG2RAD,
            (config.rotation.y + rotation.y) * DEG2RAD,
            (config.rotation.z + rotation.z) * DEG2RAD,
        );

      }



    if(this.renderer){

      this.renderer.setClearColor(0x000, 0);
      this.renderer.render(this.scene, this.camera);
    }

    requestAnimationFrame(this.onEnter.bind(this));
  }



  /** 
   * TOP MVエリアに3Dオブジェクトを集めます
   */
  xGatherTop(){
    if(this.status==="opening"||this.status==="pre"){
      return;
    }
    if(this.status==="top"||this.status==="opening"||this.status==="pre"){
      return;
    }
    if(!this.isReady){
      return;
    }
    this.status="top";

    let durationTime=1.8;
    let delayTime=0.06;
    const easing="power4.out";

    var tgtList;
    if(this.breakPoint==="pc"){
      tgtList=this.top_pc;
    }else if(this.breakPoint==="tab"){
      tgtList=this.top_tab;
    }else if(this.breakPoint==="sp"){
      tgtList=this.top_sp;
    }


    //周辺に配置
    for(var i = 0; i < tgtList.length; i++){
      var obj=tgtList[i];
      var tgtMesh=this.xGetMesh(obj.name);
      gsap.killTweensOf(tgtMesh.position);
      gsap.killTweensOf(tgtMesh.scale);
      var dist=Math.max(this.wid,this.hei)*5;      
      var rad=Math.atan2(obj.y,obj.x);
      var px=dist*Math.cos(rad);
      var py=dist*Math.sin(rad);
      gsap.set(tgtMesh.position,{x:px,y:py,z:0});
      if(obj.visible){
        tgtMesh.visible=true;
      }else{
        tgtMesh.visible=false;
      }
    }

    this.topContainer.rotation.x=Math.PI*this.paramObj.topStartRoteX;
    this.topContainer.rotation.y=-Math.PI*this.paramObj.topStartRoteY;
    this.topContainer.rotation.z=Math.PI*this.paramObj.topStartRoteZ;
    this.topContainer.rotation.z=0;
    this.topContainer.position.z=1000;

    var curvePoint=this.paramObj.curvePoint;
    if(this.breakPoint!=="pc"){
      curvePoint=this.paramObj.curvePoint*0.3;
    }


    for(var i = 0; i < tgtList.length; i++){
      var obj=tgtList[i];
      var tgtMesh=this.xGetMesh(obj.name);
      if(tgtMesh){
        gsap.killTweensOf(tgtMesh.position);
        gsap.killTweensOf(tgtMesh.scale);

        var dist=Math.max(this.wid,this.hei);      
        var rad=Math.atan2(obj.y,obj.x);
        var px=dist*Math.cos(rad);
        var py=dist*Math.sin(rad);
        var px2=dist*0.5*Math.cos(rad);//+Math.random()*50-25;
        var py2=dist*0.5*Math.sin(rad)-curvePoint;
        
        const anchorsTop = [{x:px, y:py}, {x:px2, y:py2}, {x:obj.x, y:obj.y}];
        const rawPathTop = MotionPathPlugin.arrayToRawPath(anchorsTop, {curviness:this.paramObj.curviness});
        const pathTop =MotionPathPlugin.rawPathToString( rawPathTop );

        if(obj.name.indexOf("planeTop")>-1){

          gsap.to(tgtMesh.position,{duration:durationTime,z:obj.z,x:obj.x, y:obj.y,
            ease:"power4.out",delay:i*delayTime});
          gsap.to(tgtMesh.scale,{duration:durationTime,x:obj.sX,y:obj.sY,z:obj.sZ,ease:"power4.out",delay:i*delayTime});
          gsap.to(tgtMesh.rotation,{duration:durationTime,x:obj.rX,y:obj.rY,z:obj.rZ,ease:"power4.out",delay:i*delayTime});
        }else{
          
          gsap.to(tgtMesh.position,{duration:durationTime,z:obj.z,//x:obj.x, y:obj.y,
            motionPath: {
              path: pathTop,
              autoRotate: true
            },
            ease:"power4.out",delay:i*delayTime});
          gsap.to(tgtMesh.scale,{duration:durationTime,x:obj.sX,y:obj.sY,z:obj.sZ,ease:"power4.out",delay:i*delayTime});
          gsap.to(tgtMesh.rotation,{duration:durationTime,x:obj.rX,y:obj.rY,z:obj.rZ,ease:"power4.out",delay:i*delayTime});
        }
      }
    }

    this.container.rotation.x=30/180*Math.PI;
    this.container.rotation.y=30/180*Math.PI;
    gsap.killTweensOf(this.container.rotation);
    gsap.killTweensOf(this.topContainer.position);
    gsap.killTweensOf(this.topContainer.rotation);
    gsap.to(this.container.rotation,{duration:1.6,x:0,y:0,ease:"power4.out",delay:0.0});//planeTopのため
    gsap.to(this.topContainer.position,{duration:2.4,delay:0.4,x:0,y:0,z:0,ease:"power4.out"});
    gsap.to(this.topContainer.rotation,{duration:3.6,delay:0.4,x:0,y:0,z:0,ease:"power4.out"});

  }


  /** 
   * TOP CENTER CIRCLEエリアに3Dオブジェクトを集めます
   */
   xGatherCenter(){
    if(this.status==="center"){
      return;
    }
    this.status="center";
    if(!this.isReady){
      return;
    }
    
    let durationTime=1;
    let delayTime=0.02;
    const easing=Power3.easeInOut;

    

    var tgtList;
    if(this.breakPoint==="pc"){
      tgtList=this.center_pc;
    }else if(this.breakPoint==="tab"){
      tgtList=this.center_tab;
    }else if(this.breakPoint==="sp"){
      tgtList=this.center_sp;
    }


    //周辺に配置
    for(var i = 0; i < tgtList.length; i++){
      var obj=tgtList[i];
      var tgtMesh=this.xGetMesh(obj.name);
      gsap.killTweensOf(tgtMesh.position);
      gsap.killTweensOf(tgtMesh.scale);
      var dist=Math.max(this.wid,this.hei);
      if(this.paramObj.productCenter){
        dist=0;
      }else{
        dist=2000;
      }
      
      var rad=Math.atan2(obj.y,obj.x);
      var px=dist*Math.cos(rad);
      var py=dist*Math.sin(rad);
      gsap.set(tgtMesh.position,{x:px,y:py,z:0});
      if(obj.visible){
        tgtMesh.visible=true;
      }else{
        tgtMesh.visible=false;
      }
    }

    this.topContainer.rotation.x=Math.PI*this.paramObj.centerStartRoteX;
    this.topContainer.rotation.y=-Math.PI*this.paramObj.centerStartRoteY;
    this.topContainer.rotation.z=Math.PI*this.paramObj.centerStartRoteZ;

    var curvePoint=this.paramObj.curvePoint;
    if(this.breakPoint!=="pc"){
      curvePoint=this.paramObj.curvePoint*0.3;
    }

    for(var i = 0; i < tgtList.length; i++){
      var obj=tgtList[i];
      var tgtMesh=this.xGetMesh(obj.name);
      if(obj.name.indexOf("logo")>-1){
        durationTime=0.1;
        delayTime=0;
      }else{
        durationTime=1.6;
        delayTime=0.03;
      }
      if(tgtMesh){
        gsap.killTweensOf(tgtMesh.position);
        gsap.killTweensOf(tgtMesh.scale);

        var dist=Math.max(this.wid,this.hei);      
        var rad=Math.atan2(obj.y,obj.x);
        var px=dist*Math.cos(rad);
        var py=dist*Math.sin(rad);
        var px2=dist*0.5*Math.cos(rad);//+Math.random()*50-25;
        var py2=dist*0.5*Math.sin(rad)-curvePoint;
        
        const anchorsTop = [{x:px, y:py}, {x:px2, y:py2}, {x:obj.x, y:obj.y}];
        const rawPathTop = MotionPathPlugin.arrayToRawPath(anchorsTop, {curviness:this.paramObj.curviness});
        const pathTop =MotionPathPlugin.rawPathToString( rawPathTop );


        gsap.to(tgtMesh.position,{duration:durationTime,z:obj.z,//x:obj.x, y:obj.y,
          motionPath: {
            path: pathTop,
            autoRotate: true
          },
          ease:"power4.out",delay:i*delayTime});
        gsap.to(tgtMesh.scale,{duration:durationTime,x:obj.sX,y:obj.sY,z:obj.sZ,ease:"power4.out",delay:i*delayTime});
        gsap.to(tgtMesh.rotation,{duration:durationTime,x:obj.rX,y:obj.rY,z:obj.rZ,ease:"power4.out",delay:i*delayTime});
      }
    }

    gsap.killTweensOf(this.topContainer.position);
    gsap.killTweensOf(this.topContainer.rotation);
    gsap.to(this.topContainer.position,{duration:2.4,delay:0.0,x:0,y:0,z:0,ease:"power4.out"});
    gsap.to(this.topContainer.rotation,{duration:2.4,delay:0.0,x:0,y:0,z:0,ease:"power4.out"});
  }

  /** 
   * TOP BOTTOMエリアに3Dオブジェクトを集めます
   */
   xGatherBottom(){
    if(this.status==="bottom"){
      return;
    }
    this.status="bottom";
    if(!this.isReady){
      return;
    }
    
    let durationTime=2;
    let delayTime=0.05;
    const easing="power4.out";

    var tgtList;
    if(this.breakPoint==="pc"){
      tgtList=this.bottom_pc;
    }else if(this.breakPoint==="tab"){
      tgtList=this.bottom_tab;
    }else if(this.breakPoint==="sp"){
      tgtList=this.bottom_sp;
    }


    //周辺に配置
    for(var i = 0; i < tgtList.length; i++){
      var obj=tgtList[i];
      var tgtMesh=this.xGetMesh(obj.name);
      gsap.killTweensOf(tgtMesh.position);
      gsap.killTweensOf(tgtMesh.scale);
      var dist=Math.max(this.wid,this.hei);
      var rad=Math.atan2(obj.y,obj.x);
      var px=dist*Math.cos(rad);
      var py=dist*Math.sin(rad);
      gsap.set(tgtMesh.position,{x:px,y:py,z:0});
      if(obj.visible){
        tgtMesh.visible=true;
      }else{
        tgtMesh.visible=false;
      }
    }



    for(var i = 0; i < tgtList.length; i++){
      var obj=tgtList[i];
      var tgtMesh=this.xGetMesh(obj.name);
      if(obj.name.indexOf("logo")>-1){
        durationTime=0.01;
        delayTime=0;
      }else{
        durationTime=1.5;
        delayTime=0.05;
      }
      if(tgtMesh){
        gsap.killTweensOf(tgtMesh.position);
        gsap.killTweensOf(tgtMesh.scale);
        gsap.to(tgtMesh.position,{duration:durationTime,x:obj.x,y:obj.y,z:obj.z,ease:"power4.out",delay:i*delayTime});
        gsap.to(tgtMesh.scale,{duration:durationTime,x:obj.sX,y:obj.sY,z:obj.sZ,ease:"power4.out",delay:i*delayTime});
        gsap.to(tgtMesh.rotation,{duration:durationTime,x:obj.rX,y:obj.rY,z:obj.rZ,ease:"power4.out",delay:i*delayTime});
      }
    }

    this.container.rotation.x=-90/180*Math.PI;
    this.container.rotation.y=120/180*Math.PI;
    this.container.rotation.z=70/180*Math.PI;
    gsap.killTweensOf(this.container.rotation);
    gsap.to(this.container.rotation,{duration:3.2,x:0,y:0,z:0,ease:"power4.out",delay:0.0});

  }


  /** 
   * TOP 周辺ランダムに3Dオブジェクトを散らします
   */
   xScatterRandom($offsetY,$location){
    if(this.status==="random"){
      return;
    }
    this.status="random";
    if(!this.isReady){
      return;
    }
    var offsetY=0;
    if($offsetY>0){
      offsetY=$offsetY;
    }

    gsap.to(this.container.position,{duration:2,x:0,z:0,ease:"power4.out",delay:0});

    var tgtList=this.top_pc;

    //周辺に配置
    for(var i = 0; i < tgtList.length; i++){
      var obj=tgtList[i];
      var tgtMesh=this.xGetMesh(obj.name);
      gsap.killTweensOf(tgtMesh.position);
      gsap.killTweensOf(tgtMesh.scale);
      tgtMesh.visible=false;
    }

  }


  resize($force) {
    const winW = window.innerWidth;
    if (utils.getMatchMedia() && winW === this.pastWidth && !$force){
      return;
    } 
    
    // utils.fit(this.el, true, window.innerWidth, window.innerHeight, 0, 0);
    this.pastWidth = window.innerWidth;

    //
    this.wid=window.innerWidth;
    this.hei=window.innerHeight;
    var ua = navigator.userAgent;
    if(ua.indexOf("iPhone")>-1||ua.indexOf("iPad")>-1){
      this.hei=window.screen.height;
    }
    
    if(this.wid<=500){
      if(this.breakPoint!=="sp"){
        this.breakPoint="sp";
        this.interScroll=0.5;
        this.onceChangeBreakPoint();
      }
    }else if(this.wid<=900){
      if(this.breakPoint!=="tab"){
        this.breakPoint="tab";
        this.interScroll=0.5;
        this.onceChangeBreakPoint();
      }
    }else {
      if(this.breakPoint!=="pc"){
        this.breakPoint="pc";
        this.interScroll=1;
        this.onceChangeBreakPoint();
      }
    }

    this.canvasHeight=this.hei;
    if(this.canvasHeight<800){
      this.canvasHeight=800;
    }
    this.centerX=this.wid*0.5;
    this.centerY=this.canvasHeight*0.5;

    gsap.set(this.el, {"width": this.wid, "height": this.canvasHeight});
    
    if (this.renderer) {
      this.resolution.x=this.wid;
      this.resolution.y=this.canvasHeight;
      this.dot_material.uniforms.uResolution.value = this.resolution;
      if(this.bg_noise_mesh){
        this.bg_noise_mesh.material.uniforms.uResolution.value = this.resolution;
      }
      // レンダラーのサイズを調整する
      this.renderer.setPixelRatio(2);
      this.renderer.setSize(this.wid, this.canvasHeight);

      // カメラのアスペクト比を正す
      this.camera.aspect = this.wid / this.canvasHeight;

      // ピクセル等倍の場合
      const h = this.canvasHeight;
      const cameraZ = -(h / 2) / Math.tan((this.paramObj.fov * Math.PI / 180) / 2);
      this.camera.position.set(0, 0, -cameraZ);
      this.camera.updateProjectionMatrix();

      //FOG位置調整
      this.scene.fog = new THREE.Fog(0xffffff, this.paramObj.fogN-cameraZ, this.paramObj.fogF-cameraZ);
    }
  }

  onceChangeBreakPoint(){
    this.status="reset";
  }
}

const topGl = new _topGl();

export default topGl;